// PDF functionality enabled
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DescriptionIcon from '@mui/icons-material/Description';
import UploadIcon from '@mui/icons-material/Upload';
import AddIcon from '@mui/icons-material/Add';

import React, {useEffect, useRef, useMemo} from 'react';

// Then your existing imports should follow:
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Printpage from './printbutton';
import Excelformart from './excelformart.xlsx';
import { Offline, Online } from "react-detect-offline";

import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Avatar from '@mui/material/Avatar';
import SupplyProduct from '@mui/icons-material/LocalShipping';
import AddSRV from '@mui/icons-material/PostAdd';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Search from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import PersonAdd from '@mui/icons-material/PersonAdd';
import PersonIcon from '@mui/icons-material/Person';
import Settings from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';
import Logout from '@mui/icons-material/Logout';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Show from './tableshow';
import Imagereplace from './images/Ellipse77.png';
import FormLabel from '@mui/material/FormLabel';
import Tablereport from './tablereport';
import ReactToPrint from 'react-to-print';
import * as Xlsx from 'xlsx';


import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MessageIcon from '@mui/icons-material/Message';
import SendIcon from '@mui/icons-material/Send';
import EmailIcon from '@mui/icons-material/Email';
import Attendance from './date';
import FormGroup from '@mui/material/FormGroup';

import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import {DropzoneArea} from 'material-ui-dropzone'
import PrintIcon from '@mui/icons-material/Print';
import DownloadIcon from '@mui/icons-material/Download';

import TextField from '@mui/material/TextField';
import Menustyle from './menuschools';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import CircularProgress from '@mui/material/CircularProgress';
import ImageIcon from '@mui/icons-material/Image';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import List from '@mui/material/List';
import Container from '@mui/material/Container';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import axiosInstance from './utils/axios';

import Badge from '@mui/material/Badge';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Person from './images/Ellipse77.png';

import Snack from './snack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, BrowserRouter } from "react-router-dom";
import { JsonToExcel } from 'react-json-to-excel';

import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { login } from './redux/admin';
import { loin, logout, updatestudentdata, getdata, updateStudent, deleteStudent } from './redux/students';
import { getdata_ } from './redux/class';
import { schooldetails } from './redux/schooldetails';
import { getCurrencySymbolFromSchool } from './utils/currencyFormatter';
import {
    hasFinanceFullStudentAccess,
    hasCanteenCollectorAccess,
} from './utils/financeStaffRoles';
import { useTerminology } from './hooks/useTerminology';
import { getStudentThumbnailUrl, getStudentFullImageUrl } from './utils/studentPhotoUrl';
import {
    findAcademicRecordForTerm,
    escapeHtml,
    transcriptSummaryFromRecord,
} from './utils/transcriptAcademicRecord';


const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function createData(_id,id,lastname,othernames,status,image, class_, gender, dob,hometown,residence, religion, motherlastname, motherothernames, motheroccupation, mothercontact, motheremail, motherresidence, fatherlastname,fatherothernames, fatheroccupation, fathercontact, fatheremail, fatherresidence, guardianlastname,guardianothernames, guardianoccupation, guardiancontact, guardianemail, guardianresidence, guardianrelationship,  academic , academics2, finance, attendance, Awards, behaviour, others, dailycharge, scholarship, index, specialID, nextclass, housing) 
{
    return {
        _id,
        id,
        lastname,
        othernames,
        status,
        image,
        class_,
        gender,
        dob,
        hometown,
        residence,
        religion,
        motherlastname,
        motherothernames,
        motheroccupation,
        mothercontact,
        motheremail,
        motherresidence,
        fatherlastname,
        fatherothernames,
        fatheroccupation,
        fathercontact,
        fatheremail,
        fatherresidence, 
        guardianlastname,
        guardianothernames,
        guardianoccupation,
        guardiancontact,
        guardianemail,
        guardianresidence,
        guardianrelationship,
        academic,
        academics2,
        finance,
        attendance,
        Awards,
        behaviour,
        others,
        dailycharge,
        scholarship,
        index,
        specialID,
        nextclass,
        housing, 
        
    };
}

const rows = [
    createData('Cupcake', 305, 3.7, 67, 4.3),
    createData('Donut', 452, 25.0, 51, 4.9),
    createData('Eclair', 262, 16.0, 24, 6.0),
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    createData('Gingerbread', 356, 16.0, 49, 3.9),
    createData('Honeycomb', 408, 3.2, 87, 6.5),
    createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    createData('Jelly Bean', 375, 0.0, 94, 0.0),
    createData('KitKat', 518, 26.0, 65, 7.0),
    createData('Lollipop', 392, 0.2, 98, 0.0),
    createData('Marshmallow', 318, 0, 81, 2.0),
    createData('Nougat', 360, 19.0, 9, 37.0),
    createData('Oreo', 437, 18.0, 63, 4.0),
];

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [

  
  
    {
        id: 'id',
        numeric: false,
        disablePadding: !true,
        label: 'ID',
    },
  
    {
        id: 'name',
        numeric: !true,
        disablePadding: false,
        label: 'Name',
    },
      {
        id: 'status',
        numeric: !true,
        disablePadding: false,
        label: 'Status',
    },
   
    {
        id: 'class',
        numeric: !true,
        disablePadding: false,
        label: 'Class',
    },
    {
        id: 'gender',
        numeric: !true,
        disablePadding: false,
        label: 'Gender',
    }, {
        id: 'dob',
        numeric: !true,
        disablePadding: false,
        label: 'Date of Birth',
    }, {
        id: 'address',
        numeric: !true,
        disablePadding: false,
        label: 'Address',
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: '',
    }
];


function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox" className="no-print">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all students',
                        }}
                    />
                </TableCell>
                <TableCell align="center">
                    <b>No.</b>
                </TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            <b>{headCell.label}</b>
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { numSelected, onPrint, onExport, onImport, onAdd } = props;

    return (
        <Toolbar
            sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(numSelected > 0 && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                }),
            }}
        >

            <Typography
                sx={{ flex: '1 1 100%' }}
                variant="h6"
                id="tableTitle"
                component="div"
            >
                STUDENTS
            </Typography>

            {onAdd && (
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={onAdd}
                    sx={{ ml: 2 }}
                >
                    Add Student
                </Button>
            )}

            {onImport && (
                <Button
                    variant="outlined"
                    startIcon={<UploadIcon />}
                    onClick={onImport}
                    sx={{ ml: 2 }}
                >
                    Import Excel
                </Button>
            )}

            {onExport && (
                <Button
                    variant="outlined"
                    startIcon={<DownloadIcon />}
                    onClick={onExport}
                    sx={{ ml: 2 }}
                >
                    Export Excel
                </Button>
            )}

            {onPrint && (
                <ReactToPrint
                    trigger={() => (
                        <Button
                            variant="outlined"
                            startIcon={<PrintIcon />}
                            sx={{ ml: 2 }}
                        >
                            Print
                        </Button>
                    )}
                    content={() => onPrint.current}
                    pageStyle='@page { size: A4 landscape; margin: 5mm; } @media print { body { scale:1; font-size:7pt; font-family:georgia, times, serif; } .no-print { display: none !important; } [style*="display: none"] { display: block !important; } table { font-size: 7pt; } th, td { padding: 4px !important; } }'
                />
            )}

        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

export default function EnhancedTable() {
    const dispatch = useDispatch()
    const schooldetails_ = useSelector((state) => state.schooldetails) || []
    
    // Get terminology and term options
    const { terminology, termOptions } = useTerminology();
    
    // Get currency symbol from school details - define early to ensure it's always available
    const currencySymbol = getCurrencySymbolFromSchool(schooldetails_)
    
    const [exportdata, setexportdata] = React.useState([]);
    var exporter=[]
    const componentRef = useRef(null);
    const [opensnack, setOpensnack] = React.useState(false);
    const [imageloading, setimageloading] = React.useState(true);
    const [source, setsource] = React.useState("");
    const [pageloader, setpageloader] = React.useState(true);
    const [activestudents, setactivestudents] = React.useState(true);
    const [withdrawnstudents, setwithdrawnstudents] = React.useState(false);
    const [completestudents, setcompletestudents] = React.useState(false);
    const [gettingdatatype, setgettingdatatype] = React.useState("Active");
     
    


    const handleClicksnack = () => {
        setOpensnack(true);
    };

    
    const handleClosesnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpensnack(false);
    };

    const admin = useSelector((state) => state.admin) || {}
    const stud = useSelector((state) => state.students) || []
    const isTeacher =
        ["Class Teacher", "Class and Subject Teacher", "Subject Teacher"].includes(admin.positiondescription) &&
        !(hasFinanceFullStudentAccess(admin) || hasCanteenCollectorAccess(admin));
    
    // Filter students based on selected status switches - Memoized to prevent recalculation
    const filteredStudents = useMemo(() => {
    if (activestudents && !withdrawnstudents && !completestudents) {
        // Show only active students
            return stud.filter(student => student.status === "Active");
    } else if (!activestudents && withdrawnstudents && !completestudents) {
        // Show only withdrawn students
            return stud.filter(student => student.status === "Withdrawn");
    } else if (!activestudents && !withdrawnstudents && completestudents) {
        // Show only completed students
            return stud.filter(student => student.status === "Completed");
    } else if (activestudents && withdrawnstudents && !completestudents) {
        // Show active and withdrawn students
            return stud.filter(student => student.status === "Active" || student.status === "Withdrawn");
    } else if (activestudents && !withdrawnstudents && completestudents) {
        // Show active and completed students
            return stud.filter(student => student.status === "Active" || student.status === "Completed");
    } else if (!activestudents && withdrawnstudents && completestudents) {
        // Show withdrawn and completed students
            return stud.filter(student => student.status === "Withdrawn" || student.status === "Completed");
    } else if (activestudents && withdrawnstudents && completestudents) {
        // Show all students
            return stud;
    } else {
        // Default: show only active students
            return stud.filter(student => student.status === "Active");
        }
    }, [stud, activestudents, withdrawnstudents, completestudents]);
    
    // Scope students by role/class before rendering in table.
    const schools = useMemo(() => {
        if (!isTeacher) {
            return filteredStudents;
        }

        // Supports both array format (e.g. [["JHS 1","JHS 2"]]) and flat array.
        const teacherClassesRaw = Array.isArray(admin.class_) ? admin.class_.flat() : [];
        const teacherClasses = teacherClassesRaw.filter(Boolean);

        if (teacherClasses.length !== 0) {
            return filteredStudents.filter((bug) => teacherClasses.includes(bug.class_));
        }

        // Fallback used in existing app data model for teacher's assigned class.
        if (admin.positiondescription_) {
            return filteredStudents.filter((bug) => bug.class_ === admin.positiondescription_);
        }

        return [];
    }, [filteredStudents, isTeacher, admin.class_, admin.positiondescription_]);
    const classer = useSelector((state) => state.class) || []
    const teacherClasses = Array.isArray(admin.class_) ? admin.class_.flat().filter(Boolean) : []
    const Class_ = useMemo(() => {
        if (!Array.isArray(classer)) return []
        if (!isTeacher) return classer
        if (teacherClasses.length > 0) {
            return classer.filter((bug) => teacherClasses.includes(bug.classname))
        }
        if (admin.positiondescription_) {
            return classer.filter((bug) => bug.classname === admin.positiondescription_)
        }
        return []
    }, [classer, isTeacher, teacherClasses, admin.positiondescription_])
    // var Class_ = useSelector((state) => state.class)

   
    const schooldata= async () => {
        await axiosInstance.post("https://servermain.sisrevolution.com/api/schools/getschooldata/",
            {
                schoolID:admin.schoolID

            }).then(res => {

            if (res.status === 200) {

                    dispatch(schooldetails({

                        data: res.data

                    }))


                }

            })

    }


    const gettingdata_ = async () => {
        await axiosInstance.post("https://servermain.sisrevolution.com/api/class/getclassdata/",
            {
                status:"All", // Fetch all classes, we'll filter on client side
                schoolID:admin.schoolID

            }).then(res => {

            if (res.status === 200) {

                    dispatch(getdata_({

                        data: res.data

                    }))


                }

            })

    }


    const gettingdata = async () => {
        await axiosInstance.post("https://servermain.sisrevolution.com/api/students/getstudentdata/",
            {
                status:"All", // Fetch all students, we'll filter on client side
                schoolID:admin.schoolID


            }).then(res => {

            if (res.status === 200) {

                    dispatch(getdata({

                        data: res.data

                    }))


                }

            })

    }
 
  useEffect(()=>{
    // Load school details when component mounts
    if (!schooldetails_ || schooldetails_.length === 0) {
      schooldata()
    }
    // gettingdata()
    // gettingdata_()

 
},[gettingdatatype])

  // Fetch data on component mount
  useEffect(()=>{
    // schooldata()
    // gettingdata()
    // gettingdata_()
  },[])
    
    // Memoize data calculation to prevent recalculation on every render
    const data = useMemo(() => {
        return [(schools || []).map((list, index) => createData(list._id,list.ID, list.lastname, list.othernames,list.status, list.image, list.class_, list.gender, list.dob, list.hometown, list.residence, list.religion, list.motherlastname, list.motherothernames, list.motheroccupation, list.mothercontact, list.motheremail, list.motherresidence, list.fatherlastname,  list.fatherothernames, list.fatheroccupation, list.fathercontact, list.fatheremail, list.fatherresidence, list.guardianlastname,  list.guardianothernames, list.guardianoccupation, list.guardiancontact, list.guardianemail, list.guardianresidence,list.guardianrelationship,  list.academics, Array.isArray(list.academics2) ? list.academics2 : [], list.finance, list.attendance, list.Awards, list.behaviour, list.others, list.dailyfee, list.scholarship, list.studentIndex, list.specialID, list.nextclass, list.housing))];
    }, [schools]);

    const dt = new Date()
    const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    const day = dt.getUTCDate();
    const month = String(dt.getMonth() + 1).padStart(2, '0');
    const year = dt.getFullYear();
    const date = year + "-" + month + "-" + day;
    
    // Memoize base rows from data
    const baseRows = useMemo(() => data[0] || [], [data]);
    
    console.log("data")
    console.log(data)

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('name');
    const [selected, setSelected] = React.useState([]);
    const [filerjson, setfilerjson] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(true);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorEl_, setAnchorEl_] = React.useState(null);
    const open = Boolean(anchorEl);
    const open_ = Boolean(anchorEl_);
    const [opensupply, setOpensupply] = React.useState(!true);
    const [name, setname] = React.useState(!true);
    const [location, setlocation] = React.useState(!true);
    const [allocation, setallocation] = React.useState(!true);
    const [contact, setcontact] = React.useState(!true);
    const [message, setmessage] = React.useState("");
    const [stated, setstated] = React.useState("");

    const [trialmode, settrialmode] = React.useState(!true);
    const [openadd, setOpenadd] = React.useState(!true);
    const [openaddexcel, setOpenaddexcel] = React.useState(!true);
    const [openview, setOpenview] = React.useState(!true);
    const [openattendance, setOpenattendance] = React.useState(!true);
    const [opensrv, setOpensrv] = React.useState(!true);
    const [openedit, setOpenedit] = React.useState(!true);
    const [opennotify, setOpennotify] = React.useState(!true);
    const [openimage, setOpenimage] = React.useState(!true);
    const [opendelete, setOpendelete] = React.useState(!true);
    const [openstatus, setOpenstatus] = React.useState(!true);
    const [openmessage, setOpenmessage] = React.useState(!true);
    const [opentranscript, setOpentranscript] = React.useState(!true);
    const [age, setAge] = React.useState('');
    const [attendancedata, setattendancedata] = React.useState([]);
    const [guardian, setGuardian] = React.useState('Mother');
    const [admission, setAdmission] = React.useState('new');

    const [guardianedit, setguardianedit] = React.useState('');
    const [sorter, setsorter] = React.useState("none");
    const [chosen, setchosen] = React.useState([]);
    const [filer, setfiler] = React.useState([]);
    const [loading, setloading] = React.useState(false)
    const [housing, sethousing] = React.useState("Day")
    const [search, setsearch] = React.useState("")
    const [selectedclass, setselectedclass] = React.useState("none")
    const [sortclass, setsortclass] = React.useState("none")
    
    // Memoize filtered rows for search and sortclass - Must be after search and sortclass state declarations
    const rows = useMemo(() => {
        let filtered = baseRows;
        
        // Apply search filter
        if (search !== "") {
            filtered = filtered.filter(bug => 
                (bug.class_ && bug.class_.toLowerCase().includes(search.toLowerCase())) || 
                (bug.status && bug.status.toLowerCase().includes(search.toLowerCase())) || 
                (bug.othernames && bug.othernames.toLowerCase().includes(search.toLowerCase())) || 
                (bug.lastname && bug.lastname.toLowerCase().includes(search.toLowerCase())) || 
                (bug.id && bug.id.toLowerCase().includes(search.toLowerCase())) || 
                (bug.specialID && bug.specialID.toLowerCase().includes(search.toLowerCase()))
            );
        }
        
        // Apply sortclass filter
        if (sortclass !== "none" && sortclass !== "All") {
            filtered = filtered.filter(bug => bug.class_ === sortclass);
        }
        
        return filtered;
    }, [baseRows, search, sortclass]);

    // Ensure page number stays valid when rows change (e.g., after filtering)
    useEffect(() => {
        const maxPage = Math.max(0, Math.ceil(rows.length / rowsPerPage) - 1);
        if (page > maxPage) {
            setPage(maxPage);
        }
    }, [rows.length, rowsPerPage, page]);

    const [selectedclassedit, setselectedclassedit] = React.useState("")
    const [selectedgender, setselectedgender] = React.useState("none")
    const [selectedgenderedit, setselectedgenderedit] = React.useState("")
    const [selectedreligionedit, setselectedreligionedit] = React.useState("")
    const [selectedreligion, setselectedreligion] = React.useState("none")
    const [person, setperson] = React.useState(Person)

    const [loadingguardian, setloadingguardian] = React.useState(false)
    const [loadingemail, setloadingemail] = React.useState(false)
    const [openresults, setOpenresults] = React.useState(false)
    const [resultsFilter, setResultsFilter] = React.useState('all') // 'all', 'specialExams', 'excludeSpecialExams'
    const [reopendate, setreopendate] = React.useState("")
    const [personclass, setpersonclass] = React.useState("")
    const [what, setwhat] = React.useState("back")
    const [replace, setreplace] = React.useState("no")
    const [selectedterm, setselectedterm] = React.useState(schooldetails_ && schooldetails_.length > 0 && schooldetails_[0]?.terms && schooldetails_[0].terms.length > 0 ? schooldetails_[0].terms[schooldetails_[0].terms.length-1] : "none")
    const [selectedpromote, setselectedpromote] = React.useState("none")
    const [selectedtranscriptterms, setselectedtranscriptterms] = React.useState([])
    const [whattype, setwhattype] = React.useState("back")
    const [newstudentloading, setnewstudentloading] = React.useState("false")
    const [editstudentloading, seteditstudentloading] = React.useState("false")
    const [deletestudentloading, setdeletestudentloading] = React.useState("false")
    const [smsloading, setsmsloading] = React.useState("false")
    const [status_selector, setstatus_selector] = React.useState("")
    const [emailloading, setemailloading] = React.useState("false")
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

    const searching = (e) => {
        setsearch(e.target.value)
    } 
    
    console.log("rows")
    console.log(rows)

    

    const readUploadFile = (e) => {
        // e.preventDefault();
        if(e.length!==0 && e.target.files[0].name.split(".")[1]==="xlsx"){
           
        if (e.target) {
           
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = Xlsx.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = Xlsx.utils.sheet_to_json(worksheet);
                
                setfilerjson(json)
            };
            setfiler(e.target.files[0])
            reader.readAsArrayBuffer(e.target.files[0]);
            
        }
    }else{

        handleClicksnack()
        setmessage("Upload Excel Data Only")
        setstated("error")

    }
    }


const uloadsxcel=()=>{

setnewstudentloading(true)

const fd = new FormData()
                  
                    fd.append("files",filer)
                    fd.append("schoolID",admin.schoolID)
                   
                    const uploading = async() => {
                        try {
                            const res = await axiosInstance.post("https://servermain.sisrevolution.com/api/students/importstudents/", fd, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                            timeout: 120000 // 2 minutes timeout for large imports
                            });

                            if (res.status === 200) {
                                // Check if response is an array (success) or error object
                                if (Array.isArray(res.data)) {
                                dispatch(getdata({
                                    data: res.data
                                }));
                                handleClicksnack();
                                    setmessage(`Student Data Imported Successfully${res.data.length > 0 ? ` (${res.data.length} students)` : ''}`);
                                setstated("success");
                                setnewstudentloading(false);
                                    handleCloseaddexcel();
                                } else if (res.data && res.data.error) {
                                    // Server returned an error object
                                    handleClicksnack();
                                    setmessage(res.data.error || "Error Importing Student Data");
                                    setstated("error");
                                    setnewstudentloading(false);
                                } else {
                                    // Empty or unexpected response
                                    handleClicksnack();
                                    setmessage("Import completed but no data returned");
                                    setstated("warning");
                                    setnewstudentloading(false);
                                }
                            } else {
                                handleClicksnack();
                                setmessage("Error Importing Student Data");
                                setstated("error");
                                setnewstudentloading(false);
                            }
                        } catch (error) {
                            console.error('Excel import error:', error);
                            setnewstudentloading(false);
                            handleClicksnack();
                            
                            if (error.code === 'ECONNABORTED') {
                                setmessage("Import timeout - please try again");
                                setstated("error");
                            } else if (error.response) {
                                const errorMsg = error.response.data?.error || `Server error: ${error.response.status}`;
                                setmessage(errorMsg);
                                setstated("error");
                            } else if (error.request) {
                                setmessage("Network error - please check your connection");
                                setstated("error");
                            } else {
                                setmessage("Import failed - please try again");
                                setstated("error");
                            }
                        }
                    }
                    uploading();

}

    //actions

    const grading = (score) => {
     
  if(!schooldetails_ || schooldetails_.length === 0 || !schooldetails_[0]?.grades || schooldetails_[0].grades.length === 0){

    handleClicksnack()
    setmessage("setup your grades at settings")
    setstated("error")
    return "F"

  }else{


    var value_= schooldetails_[0].grades.filter(bug=>bug.upperlimit>=score && bug.lowerlimit<=score)
   
    if(value_.length===0){
    return "F"
    }else{
        return value_[0].gradepoint
    }
  }

    }



    const remarks = (grade) => {
        if(!schooldetails_ || schooldetails_.length === 0 || !schooldetails_[0]?.grades || schooldetails_[0].grades.length === 0){

            handleClicksnack()
            setmessage("setup your grades at settings")
            setstated("error")
            return "Fail"
        
          }else{
        
        var value_= schooldetails_[0].grades.filter(bug=>bug.upperlimit>=grade && bug.lowerlimit<=grade)
        if(value_.length===0){
            return "Fail"
            }else{
                return value_[0].remarks
            }
     
          }
    }
    
    const registerstudent = () => {
                    setnewstudentloading(true)
                    if(!schooldetails_ || schooldetails_.length === 0 || !schooldetails_[0]?.studentpopulation) {
                        handleClicksnack()
                        setmessage("School details not loaded. Please refresh the page.")
                        setstated("error")
                        setnewstudentloading(false)
                        return
                    }
                    const max = (schooldetails_[0].studentpopulation).split("-")[1]
                    const file = document.getElementById("fileimage").files[0]
                    const image = ""
                    const lastname = document.getElementById("lastname").value
                    const othernames = document.getElementById("othernames").value
                    const specialID = document.getElementById("specialID").value
                    const dob = document.getElementById("dob").value
                    const residence = document.getElementById("residence").value
                    const hometown = document.getElementById("hometown").value
                    const religion = selectedreligion
                    const gender = selectedgender
                    const class_ = selectedclass
                    const motherlastname = document.getElementById("motherlastname").value
                    const motherothernames = document.getElementById("motherothernames").value
                    const motheroccupation = document.getElementById("motheroccupation").value
                    const mothercontact = document.getElementById("mothercontact").value
                    const motheremail = document.getElementById("motheremail").value
                    const motherresidence = document.getElementById("motherresidence").value 
                                
                    const fatherlastname = document.getElementById("fatherlastname").value
                    const fatherothernames = document.getElementById("fatherothernames").value
                    const fatheroccupation = document.getElementById("fatheroccupation").value
                    const fathercontact = document.getElementById("fathercontact").value
                    const fatheremail = document.getElementById("fatheremail").value
                    const fatherresidence = document.getElementById("fatherresidence").value
                    const dailyfee = document.getElementById("dailyfee").value
                    const scholarship = document.getElementById("scholarship").value
                    const weeklyfee = document.getElementById("weeklyfee").value
                    const monthlyfee = document.getElementById("monthlyfee").value
                    const index = document.getElementById("index").value
                    
                    var  guardianlastname = ""
                    var  guardianothernames = ""
                    var  guardianoccupation = ""
                    var  guardiancontact = ""
                    var  guardianemail = ""
                    var  guardianresidence = ""
                    var  guardianrelationship = ""
                   
                   

                    const classInfo = (Array.isArray(Class_) ? Class_ : []).find((bug) => bug.classname === class_);
                    const nextclass =
                        class_ !== "none" && class_ !== ""
                            ? (classInfo?.nextclass ?? class_)
                            : class_;
                    if(guardian === "Mother" || guardian === "Parents" ){

                    guardianlastname = document.getElementById("motherlastname").value
                    guardianothernames = document.getElementById("motherothernames").value
                    guardianoccupation = document.getElementById("motheroccupation").value
                    guardiancontact = document.getElementById("mothercontact").value
                    guardianemail = document.getElementById("motheremail").value
                    guardianresidence = document.getElementById("motherresidence").value
                    guardianrelationship = "Mother" 

                    }    

                    if(guardian === "Others" ){

                    guardianlastname = document.getElementById("guardianlastname").value
                    guardianothernames = document.getElementById("guardianothernames").value
                    guardianoccupation = document.getElementById("guardianoccupation").value
                    guardiancontact = document.getElementById("guardiancontact").value
                    guardianemail = document.getElementById("guardianemail").value
                    guardianresidence = document.getElementById("guardianaddress").value
                    guardianrelationship = "Guardian"

                    }
                    
                    if(guardian === "Father" ){

                    guardianlastname = document.getElementById("fatherlastname").value
                    guardianothernames = document.getElementById("fatherothernames").value
                    guardianoccupation = document.getElementById("fatheroccupation").value
                    guardiancontact = document.getElementById("fathercontact").value
                    guardianemail = document.getElementById("fatheremail").value
                    guardianresidence = document.getElementById("fatherresidence").value
                    guardianrelationship = "Father"

                    }
              
                    const fd = new FormData()
                   
                    if (file) {
                   
                        fd.append("file", file)
                        fd.append("image", document.getElementById("fileimage").files[0].name)
                    }
                    
                    fd.append("lastname", lastname)
                    fd.append("schoolID",admin.schoolID)
                    fd.append("smsID",admin.smsID)
                    fd.append("newstudent",admission)
                    fd.append("smsname",admin.smsname)
                    fd.append("schoolname",admin.schoolname)
                    fd.append("othernames", othernames)
                    fd.append("class_", class_)
                    fd.append("nextclass", nextclass)
                    fd.append("gender", gender)
                    fd.append("dob", dob)
                    fd.append("hometown", hometown)
                    fd.append("max", max)
                    fd.append("residence", residence)
                    fd.append("religion", religion)
                    fd.append("motherlastname", motherlastname)
                    fd.append("motherothernames", motherothernames)
                    fd.append("motheroccupation", motheroccupation)
                    fd.append("mothercontact", mothercontact)
                    fd.append("motheremail", motheremail)
                    fd.append("motherresidence", motherresidence)
                    fd.append("fatherresidence", fatherresidence)
                    fd.append("fatherlastname", fatherlastname)
                    fd.append("fatherothernames", fatherothernames)
                    fd.append("fatheroccupation", fatheroccupation)
                    fd.append("fathercontact", fathercontact)
                    fd.append("fatheremail", fatheremail)
                    fd.append("index", index)
                    fd.append("housing", housing)
                    fd.append("guardianresidence", guardianresidence)
                    fd.append("guardianlastname", guardianlastname)
                    fd.append("guardianothernames", guardianothernames)
                    fd.append("guardianoccupation", guardianoccupation)
                    fd.append("guardiancontact", guardiancontact)
                    fd.append("guardianemail", guardianemail)
                    fd.append("spacialID", specialID)
                    fd.append("scholarship", scholarship)
                    fd.append("guardianrelationship", guardianrelationship)
                    fd.append("admissiontype", admission)
                    fd.append("status", gettingdatatype)

                    const uploading = async() => {
                        try {
                            const res = await axiosInstance.post("https://servermain.sisrevolution.com/api/students/registerstudent/", fd, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                            });

                            if (res.status === 200) {
                                dispatch(getdata({
                                    data: res.data
                                }));
                                handleCloseadd();
                                handleClicksnack();
                                setmessage("New Student Added");
                                setstated("success");
                                setnewstudentloading(false);
                            } else if (res.status === 208) {
                                handleCloseadd();
                                handleClicksnack();
                                setmessage("Maximum Number Of Active Students Reached");
                                setstated("error");
                                setnewstudentloading(false);
                            } else if (res.status === 204) {
                                handleCloseadd();
                                handleClicksnack();
                                setmessage("Error Adding Student");
                                setstated("error");
                                setnewstudentloading(false);
                            }
                        } catch (error) {
                            console.error('Upload error:', error);
                            handleCloseadd();
                            handleClicksnack();
                            
                            if (error.code === 'ECONNABORTED') {
                                setmessage("Upload timeout - please try again");
                            } else if (error.response) {
                                setmessage(`Server error: ${error.response.status}`);
                            } else if (error.request) {
                                setmessage("Network error - please check your connection");
                            } else {
                                setmessage("Upload failed - please try again");
                            }
                            setstated("error");
                            setnewstudentloading(false);
                        }
                    }

if(class_ === "none" || class_ === ""){
        handleClicksnack()
        setmessage("Please set class")
        setstated("error")
    setnewstudentloading(false)
} else {
        uploading()
}



                }

    const editstudent = () => {
                    seteditstudentloading(true)

                    const file = document.getElementById("fileimageedit").files[0]
                    const image = ""
                    const lastname = document.getElementById("lastnameedit").value
                    const othernames = document.getElementById("othernamesedit").value
                    const specialIDedit = document.getElementById("specialIDedit").value
                    const dob = document.getElementById("dobedit").value
                    const residence = document.getElementById("residenceedit").value
                    const hometown = document.getElementById("hometownedit").value
                    const religion = selectedreligionedit
                    const gender = selectedgenderedit
                    const class_ = selectedclassedit || chosen.class_
                    const motherlastname = document.getElementById("motherlastnameedit").value
                    const motherothernames = document.getElementById("motherothernamesedit").value
                    const motheroccupation = document.getElementById("motheroccupationedit").value
                    const mothercontact = document.getElementById("mothercontactedit").value
                    const motheremail = document.getElementById("motheremailedit").value
                    const motherresidence = document.getElementById("motherresidenceedit").value 
                                
                    const fatherlastname = document.getElementById("fatherlastnameedit").value
                    const fatherothernames = document.getElementById("fatherothernamesedit").value
                    const fatheroccupation = document.getElementById("fatheroccupationedit").value
                    const fathercontact = document.getElementById("fathercontactedit").value
                    const fatheremail = document.getElementById("fatheremailedit").value
                    const fatherresidence = document.getElementById("fatherresidenceedit").value
                    const dailyfeeedit = document.getElementById("dailyfeeedit").value
                    const scholarshipedit = document.getElementById("scholarshipedit").value
                    const index = document.getElementById("indexedit").value
                    const classInfo = (Array.isArray(Class_) ? Class_ : []).find((bug) => bug.classname === class_);
                    const nextclass = classInfo?.nextclass ?? class_;

                    
                    var  guardianlastname = ""
                    var  guardianothernames = ""
                    var  guardianoccupation = ""
                    var  guardiancontact = ""
                    var  guardianemail = ""
                    var  guardianresidence = ""
                    var  guardianrelationship = ""
                    
                    if(guardianedit === "Mother" || guardianedit === "Parents" ){

                    guardianlastname = document.getElementById("motherlastnameedit").value
                    guardianothernames = document.getElementById("motherothernamesedit").value
                    guardianoccupation = document.getElementById("motheroccupationedit").value
                    guardiancontact = document.getElementById("mothercontactedit").value
                    guardianemail = document.getElementById("motheremailedit").value
                    guardianresidence = document.getElementById("motherresidenceedit").value
                    guardianrelationship = "Mother" 

                    }    

                    if(guardianedit === "Others" ){

                    guardianlastname = document.getElementById("guardianlastnameedit").value
                    guardianothernames = document.getElementById("guardianothernamesedit").value
                    guardianoccupation = document.getElementById("guardianoccupationedit").value
                    guardiancontact = document.getElementById("guardiancontactedit").value
                    guardianemail = document.getElementById("guardianemailedit").value
                    guardianresidence = document.getElementById("guardianaddressedit").value
                    guardianrelationship = "Guardian"

                    }
                    
                    if(guardianedit === "Father" ){

                    guardianlastname = document.getElementById("fatherlastnameedit").value
                    guardianothernames = document.getElementById("fatherothernamesedit").value
                    guardianoccupation = document.getElementById("fatheroccupationedit").value
                    guardiancontact = document.getElementById("fathercontactedit").value
                    guardianemail = document.getElementById("fatheremailedit").value
                    guardianresidence = document.getElementById("fatherresidenceedit").value
                    guardianrelationship = "Father"

                    }
              
                    const fd = new FormData()
                   
                    if (file) {
                   
                        fd.append("file", file)
                        fd.append("image", dob+lastname+".jpg")
                    }
                    fd.append("_id", chosen._id)
                    fd.append("schoolID",admin.schoolID)
                    fd.append("lastname", lastname)
                    fd.append("othernames", othernames)
                    fd.append("class_", class_)
                    fd.append("nextclass", nextclass)
                    fd.append("gender", gender)
                    fd.append("dob", dob)
                    fd.append("housing", housing)
                    fd.append("hometown", hometown)
                    fd.append("residence", residence)
                    fd.append("religion", religion)
                    fd.append("motherlastname", motherlastname)
                    fd.append("motherothernames", motherothernames)
                    fd.append("motheroccupation", motheroccupation)
                    fd.append("mothercontact", mothercontact)
                    fd.append("motheremail", motheremail)
                    fd.append("motherresidence", motherresidence)
                    fd.append("fatherresidence", fatherresidence)
                    fd.append("fatherlastname", fatherlastname)
                    fd.append("fatherothernames", fatherothernames)
                    fd.append("fatheroccupation", fatheroccupation)
                    fd.append("fathercontact", fathercontact)
                    fd.append("fatheremail", fatheremail)
                    fd.append("dailyfee", dailyfeeedit)
                    fd.append("scholarship", scholarshipedit)
                    fd.append("specialID", specialIDedit)

                    fd.append("guardianresidence", guardianresidence)
                    fd.append("guardianlastname", guardianlastname)
                    fd.append("guardianothernames", guardianothernames)
                    fd.append("guardianoccupation", guardianoccupation)
                    fd.append("guardiancontact", guardiancontact)
                    fd.append("guardianemail", guardianemail)
                    fd.append("guardianrelationship", guardianrelationship)
                    fd.append("status", gettingdatatype)

                    const uploading = async() => {
                        try {
                            const res = await axiosInstance.post("https://servermain.sisrevolution.com/api/students/editstudent/", fd, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                            });

                            if (res.status === 200) {
                                // Create updated student data from form values
                                const updatedStudentData = {
                                    lastname: lastname,
                                    othernames: othernames,
                                    class_: class_,
                                    nextclass: nextclass,
                                    gender: gender,
                                    dob: dob,
                                    hometown: hometown,
                                    residence: residence,
                                    religion: religion,
                                    motherlastname: motherlastname,
                                    motherothernames: motherothernames,
                                    motheroccupation: motheroccupation,
                                    mothercontact: mothercontact,
                                    motheremail: motheremail,
                                    motherresidence: motherresidence,
                                    fatherlastname: fatherlastname,
                                    fatherothernames: fatherothernames,
                                    fatheroccupation: fatheroccupation,
                                    fathercontact: fathercontact,
                                    fatheremail: fatheremail,
                                    fatherresidence: fatherresidence,
                                    dailyfee: dailyfeeedit,
                                    scholarship: scholarshipedit,
                                    specialID: specialIDedit,
                                    guardianlastname: guardianlastname,
                                    guardianothernames: guardianothernames,
                                    guardianoccupation: guardianoccupation,
                                    guardiancontact: guardiancontact,
                                    guardianemail: guardianemail,
                                    guardianresidence: guardianresidence,
                                    guardianrelationship: guardianrelationship,
                                    status: gettingdatatype
                                };

                                // Update the specific student in Redux store
                                dispatch(updateStudent({
                                    studentId: chosen._id,
                                    updatedData: updatedStudentData
                                }));

                                handleCloseedit();
                                handleClicksnack();
                                setmessage("Student Data Edited");
                                setstated("success");
                                seteditstudentloading(false);
                            } else if (res.status === 204) {
                                handleCloseedit();
                                handleClicksnack();
                                setmessage("Error Editing Student");
                                setstated("error");
                                seteditstudentloading(false);
                            }
                        } catch (error) {
                            console.error('Edit upload error:', error);
                            handleCloseedit();
                            handleClicksnack();
                            
                            if (error.code === 'ECONNABORTED') {
                                setmessage("Upload timeout - please try again");
                            } else if (error.response) {
                                setmessage(`Server error: ${error.response.status}`);
                            } else if (error.request) {
                                setmessage("Network error - please check your connection");
                            } else {
                                setmessage("Upload failed - please try again");
                            }
                            setstated("error");
                            seteditstudentloading(false);
                }
                    }

                    uploading();

                }

    const sendsms = () => {
                    setsmsloading(true)

                       
                    const message = document.getElementById("viasms").value
                   
                
                    const fd = new FormData()
                  
                    fd.append("message", message)
                    fd.append("schoolID",chosen.schoolID)
                    fd.append("studentID",chosen.ID)
                    if(!schooldetails_ || schooldetails_.length === 0) {
                        handleClicksnack()
                        setmessage("School details not loaded. Please refresh the page.")
                        setstated("error")
                        setsmsloading(false)
                        return
                    }
                    fd.append("sender",schooldetails_[0].schoolname || '')
                    fd.append("smsname",schooldetails_[0].smsname || '')
                    fd.append("smsID",schooldetails_[0].smsID || '')
                    fd.append("image",schooldetails_[0].image || '')
                    fd.append("contact", chosen.guardiancontact)
                    fd.append("guadianname", chosen.guardianlastname)
                    const uploading = async() => {
                        try {
                            const res = await axiosInstance.post("https://servermain.sisrevolution.com/api/students/singlesms/", fd, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                            });

                            if (res.status === 200) {
                                setsmsloading(false);
                                handleCloseadd();
                                handleClicksnack();
                                setmessage("SMS sent");
                                setstated("success");
                            } else if (res.status === 204) {
                                setsmsloading(false);
                                handleClicksnack();
                                setmessage("Error Sending SMS");
                                setstated("error");
                            } else {
                                setsmsloading(false);
                                handleClicksnack();
                                setmessage("Error Sending SMS");
                                setstated("error");
                            }
                        } catch (error) {
                            console.error('SMS error:', error);
                            setsmsloading(false);
                            handleClicksnack();
                            
                            if (error.code === 'ECONNABORTED') {
                                setmessage("SMS timeout - please try again");
                            } else if (error.response) {
                                setmessage(`Server error: ${error.response.status}`);
                            } else if (error.request) {
                                setmessage("Network error - please check your connection");
                            } else {
                                setmessage("SMS failed - please try again");
                            }
                            setstated("error");
                        }
                    }
                    uploading();
                }

    const sendemail = () => {
                    setemailloading(true)
     
                    const messagesms = document.getElementById("viaemail").value
                    const subject = document.getElementById("emailsubject").value
                   
                    const fd = new FormData()
                  
                    fd.append("message", messagesms)
                    if(!schooldetails_ || schooldetails_.length === 0) {
                        handleClicksnack()
                        setmessage("School details not loaded. Please refresh the page.")
                        setstated("error")
                        setemailloading(false)
                        return
                    }
                    fd.append("logo", schooldetails_[0].logo || '')
                    fd.append("Schoolname", schooldetails_[0].schoolname || '')
                    fd.append("email", schooldetails_[0].email || '')
                    fd.append("contact", schooldetails_[0].contact || '')
                    fd.append("address", schooldetails_[0].address || '')
                    fd.append("schoolID",admin.schoolID)
                    fd.append("guardianemail", chosen.guardianemail)
                    fd.append("guardian", chosen.guardianlastname)
                    fd.append("subject", subject)

                    const uploading = async() => {
                        try {
                            const res = await axiosInstance.post("https://servermain.sisrevolution.com/api/students/singleemail/", fd, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                            });

                            if (res.status === 200) {
                                setemailloading(false);
                                handleCloseadd();
                                handleClicksnack();
                                setmessage("Email sent");
                                setstated("success");
                            } else if (res.status === 204) {
                                setemailloading(false);
                                handleCloseadd();
                                handleClicksnack();
                                setmessage("Error Sending Email");
                                setstated("error");
                            } else {
                                setemailloading(false);
                                handleClicksnack();
                                setmessage("Error Sending Email");
                                setstated("error");
                            }
                        } catch (error) {
                            console.error('Email error:', error);
                            setemailloading(false);
                            handleClicksnack();
                            
                            if (error.code === 'ECONNABORTED') {
                                setmessage("Email timeout - please try again");
                            } else if (error.response) {
                                setmessage(`Server error: ${error.response.status}`);
                            } else if (error.request) {
                                setmessage("Network error - please check your connection");
                            } else {
                                setmessage("Email failed - please try again");
                            }
                            setstated("error");
                        }
                    }
                    uploading();

                }

    const deleter = (data) => {

         setdeletestudentloading(true)

        const doer = async () => {
            await axiosInstance.post("https://servermain.sisrevolution.com/api/students/deletestudent/",
                {
                   _id:chosen._id,
                   schoolID:admin.schoolID

                }).then(res => {

                    if (res.status === 200) {

                        // Update Redux store by removing the deleted student
                        dispatch(deleteStudent(chosen._id));

                        setdeletestudentloading(!true)
                        handleClosedelete()
                        handleClicksnack()
                        setmessage("Data has been deleted")
                        setstated("success")

                    } else {
                        setdeletestudentloading(!true)
                        handleClosedelete()
                        handleClicksnack()
                        setmessage("Error deleting data")
                        setstated("error")
                    }

                })

        }

        try{
            doer()
        }
        catch(err){
            handleClicksnack()
            setmessage("Network Error")
            setstated("error")
            setdeletestudentloading(false)
        }

    }
 

    const changestatus = (data) => {

         setdeletestudentloading(true)

        const doer = async () => {
            await axiosInstance.post("https://servermain.sisrevolution.com/api/students/changestatus/",
                {
                   _id:chosen._id,
                   status:status_selector,
                   schoolID:admin.schoolID

                }).then(res => {

                    if (res.status === 200) {

                        // Update the specific student's status in Redux store
                        dispatch(updateStudent({
                            studentId: chosen._id,
                            updatedData: { status: status_selector }
                        }));

                        setdeletestudentloading(!true)
                        handleClosestatus()
                        handleClicksnack()
                        setmessage("student status changed to "+status_selector)
                        setstated("success")

                    } else {
                        setdeletestudentloading(!true)
                        handleClosestatus()
                        handleClicksnack()
                        setmessage("Error changing status")
                        setstated("error")
                    }

                })

        }
try{
            doer()
        }
        catch(err){
            handleClicksnack()
            setmessage("Network Error")
            setstated("error")
            setdeletestudentloading(false)
        }

    }

    
    const sendviatext = (list) => {

        setloadingguardian(true)
        var data = list.academic.filter(bug => bug.term === selectedterm)
        // setsmssend(true)
        var guardianname = (list.guardianlastname).toUpperCase()
        var guardiancontact = list.guardiancontact
        var student = (list.lastname).toUpperCase() + " " + (list.othernames).toUpperCase()
        var id = list._id


        const senddatatext = async () => {
            await axiosInstance.post("https://servermain.sisrevolution.com/api/students/sendresultstext/",
                {
                    id: id,
                    data: data,
                    guardianname: guardianname,
                    guardiancontact: guardiancontact,
                    student: student,
                    term: selectedterm,
                    reopening: schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0].reopendate : '',
                    schoolID:admin.schoolID,
                    smsID:schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0].smsID : '',
                    smsname:schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0].smsname : '',
                    position:Class_.filter(bug=>bug.classname === list.class_)[0].position,
                    aggregate:Class_.filter(bug=>bug.classname === list.class_)[0].aggregate,
                    filterType: resultsFilter,
                    class_: list.class_


                }).then(res => {

                    if (res.status === 200) {
                            // setsmssend(false)
                            // handleClose()
                            setloadingguardian(false)

                            handleClicksnack()
                            setmessage("Results sent to parent")
                            setstated("success")


                    }else{
                        // setsmssend(false)
                        setloadingguardian(false)

                        handleClicksnack()
                        setmessage("Error sending results")
                        setstated("error")
                    }

                })

        }

        if (selectedterm !== "none") {
            if(!schooldetails_ || schooldetails_.length === 0 || !schooldetails_[0]?.payment || schooldetails_[0].payment.length === 0 || schooldetails_[0].payment[schooldetails_[0].payment.length-1].amount === "trial" ){

                settrialmode(true)
                setloadingguardian(true)

    
            }else{

                try{
                senddatatext()
                }catch(err){
                    handleClicksnack()
                    setloadingguardian(true)
                    setmessage("Network Error")
                    setstated("error")

                }

            }
        }

    }


    const sendviaemail = (list) => {

        setloadingemail(true)
        var data = list.academic.filter(bug => bug.term === selectedterm)
        // setsmssend(true)
        var guardianname = (list.lastname).toUpperCase()
        var guardiancontact = list.guardiancontact
        var guardianemail = list.guardianemail
        var student = (list.lastname).toUpperCase() + " " + (list.othernames).toUpperCase()
        var id = list._id


        const senddatatext = async () => {
            await axiosInstance.post("https://servermain.sisrevolution.com/api/students/sendresultsemail/",
                {
                    id: id,
                    data: data,
                    guardianname: guardianname,
                    guardiancontact: guardiancontact,
                    guardianemail: guardianemail,
                    student: student,
                    term: selectedterm,
                    ID_:list.id,
                    class_:list.class_,
                    reopening: schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0].reopendate : '',
                    schoolname: schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0].schoolname : '',
                    address: schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0].address : '',
                    contact: schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0].contact : '',
                    schoolID:admin.schoolID,
                    smsID:schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0].smsID : '',
                    smsname:schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0].smsname : '',
                    position:Class_.filter(bug=>bug.classname === list.class_)[0].position,
                    aggregate:Class_.filter(bug=>bug.classname === list.class_)[0].aggregate,
                    filterType: resultsFilter


                }).then(res => {
console.log(res)
                    if (res.status === 200) {
                            // setsmssend(false)
                            // handleClose()
                            setloadingemail(false)

                            handleClicksnack()
                            setmessage("Results sent to parent")
                            setstated("success")


                    }else{
                        // setsmssend(false)
                        setloadingemail(false)

                        handleClicksnack()
                        setmessage("Error sending results")
                        setstated("error")
                    }

                })

        }

        if (selectedterm !== "none") {
            if(!schooldetails_ || schooldetails_.length === 0 || !schooldetails_[0]?.payment || schooldetails_[0].payment.length === 0 || schooldetails_[0].payment[schooldetails_[0].payment.length-1].amount === "trial" ){

                settrialmode(true)
                setloadingemail(true)

    
            }else{

                try{
                senddatatext()
                }catch(err){
                    handleClicksnack()
                    setloadingemail(true)
                    setmessage("Network Error")
                    setstated("error")

                }

            }
        }

    }

    const handleClickOpenedit = (data) => {
       
        setchosen(data)
        setselectedgenderedit(data.gender)
        sethousing(data.housing===undefined?"Day":data.housing)
        setperson(getStudentThumbnailUrl(data) || Person)
        setselectedreligionedit(data.religion)
        setselectedclassedit(data.class_)
        setguardianedit(data.guardianrelationship)
        setOpenedit(true);
    };

    const handleCloseedit = () => {
        setOpenedit(false);
    };

    const handleClickOpenimage = (data) => {
        setchosen(data)
        // var image = new Image();
        // image.src = 'https://thesis1995revolution0268005074.sisrevolution.com/sisrevolution1995/routes/uploads/'+chosen.image
        // image.onload = () => setimageloading(false);
        // image.onerror = () => setimageloading(true);
        setOpenimage(true);
    };

    const handleCloseimage = () => {
        setOpenimage(false);
    };

    const handleClickOpendelete = (data) => {
        console.log(data)
        setchosen(data)
        setOpendelete(true);
    };

    const handleClickOpenstatus = (data) => {
        setchosen(data)
        setstatus_selector(data.status)
        setOpenstatus(true);
    };

    const handleClosedelete = () => {
        setOpendelete(false);
    };

    const handleClosestatus = () => {
        setOpenstatus(false);
    };

    const handleClickOpenadd = (data) => {
       
        setOpenadd(true);
    };

    const handleCloseadd = () => {
        setOpenadd(false);
    };
    const handleClickOpenaddexcel = (data) => {
       
        setOpenaddexcel(true);
    };

    const handleCloseaddexcel = () => {
        setOpenaddexcel(false);
    };

    const handleClickOpensrv = (data) => {
        console.log(data)
        setchosen(data)
        setOpensrv(true);
    };

    const handleClosesrv = () => {
        setOpensrv(false);
    };

    const handleClickOpenview = (data) => {
        console.log(data)
        setchosen(data)
        setOpenview(true);
    };

    const handleCloseview = () => {
        setOpenview(false);
    };
   
    const handleClickOpenattendance = (data) => {
        console.log(data)
        setchosen(data)
        setOpenattendance(true);
    };

    const handleCloseattendance = () => {
        setOpenattendance(false);
    };
    
    const handleClickOpenmessage = (data) => {
        if(!schooldetails_ || schooldetails_.length === 0 || !schooldetails_[0]?.payment || schooldetails_[0].payment.length === 0 || schooldetails_[0].payment[schooldetails_[0].payment.length-1].amount === "trial" ){

            settrialmode(true)

        }else{
        console.log(data)
        setchosen(data)
        setOpenmessage(true);
        }
    };

    const handleClosemessage = () => {
        setOpenmessage(false);
    };

    const handleClickOpentranscript = (data) => {
        console.log(data)
        setchosen(data)
        setselectedtranscriptterms([]) // Reset selected terms
        setOpentranscript(true);
    };

    const handleClosetranscript = () => {
        setOpentranscript(false);
    }; 
     const handleCloseresults = () => {
        setOpenresults(false);
    };

    const handlesendresults = () => {
        setOpenresults(true);
    };


    const handlenotify = (data) => {
    
        setOpennotify(true);
    };

    const generateTranscript = (student, selectedTerms) => {
        // Create a new window for transcript printing
        const transcriptWindow = window.open('', '_blank', 'width=800,height=600');
        
        if (!transcriptWindow) {
            handleClicksnack();
            setmessage("Please allow pop-ups to generate transcript");
            setstated("warning");
            return;
        }

        // Get school details
        const school = schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0] : {};
        
        // Generate transcript HTML content
        const transcriptHTML = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Student Transcript - ${student.lastname} ${student.othernames}</title>
                <style>
                    body {
                        font-family: 'Segoe UI', Arial, sans-serif;
                        font-size: 12px;
                        line-height: 1.4;
                        margin: 20px;
                        background: white;
                    }
                    .header {
                        text-align: center;
                        margin-bottom: 30px;
                        border-bottom: 2px solid #1976d2;
                        padding-bottom: 20px;
                    }
                    .school-logo {
                        width: 80px;
                        height: 80px;
                        margin: 0 auto 10px;
                        display: block;
                    }
                    .school-name {
                        font-size: 24px;
                        font-weight: bold;
                        color: #1976d2;
                        margin: 10px 0;
                    }
                    .school-address {
                        font-size: 14px;
                        color: #666;
                        margin: 5px 0;
                    }
                    .student-info {
                        display: flex;
                        justify-content: space-between;
                        margin: 20px 0;
                        padding: 15px;
                        background: #f5f5f5;
                        border-radius: 8px;
                    }
                    .student-photo {
                        width: 100px;
                        height: 120px;
                        border: 2px solid #1976d2;
                        border-radius: 8px;
                    }
                    .info-grid {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 10px;
                        flex: 1;
                        margin-left: 20px;
                    }
                    .info-item {
                        margin: 5px 0;
                    }
                    .info-label {
                        font-weight: bold;
                        color: #1976d2;
                    }
                    .academic-section {
                        margin: 30px 0;
                    }
                    .section-title {
                        font-size: 18px;
                        font-weight: bold;
                        color: #1976d2;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 10px;
                        margin-bottom: 20px;
                    }
                    .term-table {
                        width: 100%;
                        border-collapse: collapse;
                        margin: 20px 0;
                        page-break-inside: avoid;
                    }
                    .term-table th {
                        background: #1976d2;
                        color: white;
                        padding: 10px;
                        text-align: left;
                        border: 1px solid #ddd;
                    }
                    .term-table td {
                        padding: 8px 10px;
                        border: 1px solid #ddd;
                    }
                    .term-table tr:nth-child(even) {
                        background: #f9f9f9;
                    }
                    .summary-section {
                        margin: 20px 0;
                        padding: 15px;
                        background: #f0f8ff;
                        border-radius: 8px;
                        border-left: 4px solid #1976d2;
                    }
                    .summary-grid {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 15px;
                    }
                    .print-button {
                        position: fixed;
                        top: 20px;
                        right: 20px;
                        padding: 10px 20px;
                        background: #1976d2;
                        color: white;
                        border: none;
                        border-radius: 5px;
                        cursor: pointer;
                        font-size: 14px;
                    }
                    .print-button:hover {
                        background: #1565c0;
                    }
                    @media print {
                        .print-button {
                            display: none;
                        }
                        body {
                            margin: 0;
                        }
                        .page-break {
                            page-break-before: always;
                        }
                    }
                </style>
            </head>
            <body>
                <button class="print-button" onclick="window.print()">Print Transcript</button>
                
                <div class="header">
                    ${school.image ? `<img src="https://thesis1995revolution0268005074.sisrevolution.com/sisrevolution1995/routes/logothumb/${school.image}" class="school-logo" alt="School Logo">` : ''}
                    <div class="school-name">${school.schoolname ? school.schoolname.toUpperCase() : 'SCHOOL NAME'}</div>
                    <div class="school-address">${school.address ? school.address.toUpperCase() : 'SCHOOL ADDRESS'}</div>
                    <div class="school-address">${school.contact ? school.contact : 'CONTACT'}</div>
                </div>

                <div class="student-info">
                    <div class="info-grid">
                        <div class="info-item">
                            <span class="info-label">Student Name:</span> ${student.lastname} ${student.othernames}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Student ID:</span> ${student.id || student.ID}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Class:</span> ${student.class_}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Gender:</span> ${student.gender}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Date of Birth:</span> ${student.dob ? new Date(student.dob).toLocaleDateString() : 'N/A'}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Current Status:</span> ${student.status}
                        </div>
                    </div>
                    <img src="${student.image ? getStudentThumbnailUrl(student) : 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEwMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMDAiIGhlaWdodD0iMTIwIiBmaWxsPSIjRjVGNUY1Ii8+Cjx0ZXh0IHg9IjUwIiB5PSI2MCIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEyIiBmaWxsPSIjOTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+UGhvdG8gTm90IEF2YWlsYWJsZTwvdGV4dD4KPC9zdmc+'}" class="student-photo" alt="Student Photo">
                </div>

                <div class="academic-section">
                    <div class="section-title">ACADEMIC TRANSCRIPT</div>
                    
                    ${selectedTerms.map(term => {
                        const found = findAcademicRecordForTerm(student, term);
                        if (!found) {
                            return `
                                <div style="margin: 20px 0; padding: 15px; background: #fff3cd; border: 1px solid #ffeaa7; border-radius: 5px;">
                                    <strong>${escapeHtml(terminology)}: ${escapeHtml(term)}</strong><br>
                                    No academic records available for this ${escapeHtml(String(terminology).toLowerCase())}.
                                </div>
                            `;
                        }

                        if (found.source === 'academics2') {
                            const academicRecord = found.record;
                            const subjects = academicRecord.subjects || [];
                            const summary = transcriptSummaryFromRecord(academicRecord, 'academics2');
                            const subjectRows = subjects.map((subj) => {
                                const name = subj.subjectName || subj.subject || subj.subjectId || '';
                                const classScore = subj.classScore ?? subj.class_scorre ?? 0;
                                const examScore = subj.examScore ?? subj.exam_score ?? 0;
                                const totalCell =
                                    subj.specialExamScore != null && String(subj.specialExamScore).trim() !== ''
                                        ? subj.specialExamScore
                                        : (subj.totalScore ?? subj.total ?? 0);
                                return `
                                            <tr>
                                                <td><strong>${escapeHtml(name)}</strong></td>
                                                <td>${classScore}</td>
                                                <td>${examScore}</td>
                                                <td>${escapeHtml(String(totalCell))}</td>
                                                <td>${escapeHtml(subj.grade || 'N/A')}</td>
                                                <td>${escapeHtml(subj.remarks || 'N/A')}</td>
                                            </tr>`;
                            }).join('');

                            return `
                            <div style="margin: 30px 0;">
                                <h3 style="color: #1976d2; border-bottom: 1px solid #ddd; padding-bottom: 10px;">${escapeHtml(terminology)}: ${escapeHtml(term)}</h3>
                                
                                <table class="term-table">
                                    <thead>
                                        <tr>
                                            <th>Subject</th>
                                            <th>Class Score</th>
                                            <th>Exam Score</th>
                                            <th>Total Score</th>
                                            <th>Grade</th>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        ${subjectRows}
                                    </tbody>
                                </table>

                                <div class="summary-section">
                                    <div class="summary-grid">
                                        <div class="info-item">
                                            <span class="info-label">Total Score:</span> ${summary.totalScore}
                                        </div>
                                        <div class="info-item">
                                            <span class="info-label">Position:</span> ${escapeHtml(summary.position)}
                                        </div>
                                        <div class="info-item">
                                            <span class="info-label">Aggregate:</span> ${escapeHtml(summary.aggregate)}
                                        </div>
                                        <div class="info-item">
                                            <span class="info-label">Promotion Status:</span> ${escapeHtml(summary.promotion)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `;
                        }

                        const academicRecord = found.record;
                        const subjects = academicRecord.results || [];
                        const summary = transcriptSummaryFromRecord(academicRecord, 'legacy');

                        return `
                            <div style="margin: 30px 0;">
                                <h3 style="color: #1976d2; border-bottom: 1px solid #ddd; padding-bottom: 10px;">${escapeHtml(terminology)}: ${escapeHtml(term)}</h3>
                                
                                <table class="term-table">
                                    <thead>
                                        <tr>
                                            <th>Subject</th>
                                            <th>Class Score</th>
                                            <th>Exam Score</th>
                                            <th>Total Score</th>
                                            <th>Grade</th>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        ${subjects.map(subject => `
                                            <tr>
                                                <td><strong>${escapeHtml(subject.subject || '')}</strong></td>
                                                <td>${subject.class_scorre || 0}</td>
                                                <td>${subject.exam_score || 0}</td>
                                                <td>${subject.total || 0}</td>
                                                <td>${escapeHtml(subject.grade || 'N/A')}</td>
                                                <td>${escapeHtml(subject.remarks || 'N/A')}</td>
                                            </tr>
                                        `).join('')}
                                    </tbody>
                                </table>

                                <div class="summary-section">
                                    <div class="summary-grid">
                                        <div class="info-item">
                                            <span class="info-label">Total Score:</span> ${summary.totalScore}
                                        </div>
                                        <div class="info-item">
                                            <span class="info-label">Position:</span> ${escapeHtml(summary.position)}
                                        </div>
                                        <div class="info-item">
                                            <span class="info-label">Aggregate:</span> ${escapeHtml(summary.aggregate)}
                                        </div>
                                        <div class="info-item">
                                            <span class="info-label">Promotion Status:</span> ${escapeHtml(summary.promotion)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `;
                    }).join('')}
                </div>

                <div class="summary-section">
                    <div class="section-title">OVERALL SUMMARY</div>
                    <div class="summary-grid">
                        <div class="info-item">
                            <span class="info-label">Total Terms:</span> ${selectedTerms.length}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Current Class:</span> ${student.class_}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Guardian:</span> ${student.guardianlastname} ${student.guardianothernames}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Guardian Contact:</span> ${student.guardiancontact}
                        </div>
                    </div>
                </div>

                <div style="margin: 40px 0; text-align: center; color: #666; font-size: 11px;">
                    <p>This transcript was generated on ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}</p>
                    <p>Generated by: ${school.schoolname || 'School Administration'}</p>
                </div>
            </body>
            </html>
        `;

        transcriptWindow.document.write(transcriptHTML);
        transcriptWindow.document.close();
        
        // Close the transcript dialog
        handleClosetranscript();
        
        // Show success message
        handleClicksnack();
        setmessage("Transcript generated successfully. Please print from the new window.");
        setstated("success");
    };

    const downloadAdmissionForm = async (student) => {
        try {
            // Create new jsPDF instance
            const doc = new jsPDF('p', 'mm', 'a4');
            
            // Set initial position
            let yPos = 20;
            const pageWidth = doc.internal.pageSize.width;
            const leftMargin = 20;
            const rightMargin = pageWidth - 20;
            
            // Helper function to add text with word wrapping
            const addWrappedText = (text, x, y, maxWidth, fontSize = 12) => {
                doc.setFontSize(fontSize);
                const lines = doc.splitTextToSize(text, maxWidth);
                doc.text(lines, x, y);
                return lines.length * (fontSize * 0.4); // Return height used
            };
            
            // Helper function to add underlined field
            const addUnderlinedField = (x, y, width) => {
                doc.line(x, y, x + width, y);
                return y + 5;
            };
            
            // Helper function to add checkbox
            const addCheckbox = (x, y, label) => {
                doc.rect(x, y - 3, 4, 4);
                doc.text(label, x + 8, y);
                return x + doc.getTextWidth(label) + 15;
            };
            
            // Helper function to convert image URL to base64 (for logo handling)
            const convertImageToBase64 = (url) => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.crossOrigin = 'anonymous';
                    
                    // Add timeout to prevent hanging
                    const timeout = setTimeout(() => {
                        reject(new Error('Logo conversion timeout'));
                    }, 5000); // 5 second timeout
                    
                    img.onload = () => {
                        clearTimeout(timeout);
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');
                        canvas.width = img.width;
                        canvas.height = img.height;
                        ctx.drawImage(img, 0, 0);
                        try {
                            const dataURL = canvas.toDataURL('image/jpeg');
                            resolve(dataURL);
                        } catch (e) {
                            reject(e);
                        }
                    };
                    img.onerror = (error) => {
                        clearTimeout(timeout);
                        reject(error);
                    };
                    img.src = url;
                });
            };
            
            // Header with School Logo
            // Add school logo if available - supports both data URLs and external URLs
            // with automatic conversion to base64 for PDF compatibility
            let logoAdded = false;
            if (schooldetails_ && schooldetails_.length > 0 && schooldetails_[0].logo) {
                try {
                    // Set up the logo dimensions and position
                    const logoWidth = 50;
                    const logoHeight = 50;
                    const logoX = (pageWidth - logoWidth) / 2;
                    const logoY = yPos;
                    
                    // Add a subtle background circle/ellipse behind the logo for visual appeal
                    doc.setFillColor(248, 249, 250);
                    doc.setDrawColor(220, 220, 220);
                    doc.setLineWidth(0.5);
                    doc.ellipse(logoX + logoWidth/2, logoY + logoHeight/2, logoWidth/2 + 5, logoHeight/2 + 5, 'FD');
                    
                    // Check if logo is a data URL or needs to be fetched
                    let logoData = schooldetails_[0].logo;
                    
                    // If logo is a URL, try to convert it to base64
                    if (logoData && !logoData.startsWith('data:')) {
                        // Try to convert external URL to base64
                        try {
                            const base64Logo = await convertImageToBase64(logoData);
                            doc.addImage(base64Logo, 'JPEG', logoX, logoY, logoWidth, logoHeight);
                            yPos += logoHeight + 15;
                            logoAdded = true;
                        } catch (conversionError) {
                            console.log('Could not convert logo URL to base64:', conversionError);
                            // Continue without logo
                        }
                    } else if (logoData && logoData.startsWith('data:')) {
                        // Logo is already a data URL, add it directly
                        doc.addImage(logoData, 'JPEG', logoX, logoY, logoWidth, logoHeight);
                        yPos += logoHeight + 15;
                        logoAdded = true;
                    }
                    
                    // Add a small caption below the logo if it was successfully added
                    if (logoAdded) {
                        doc.setFontSize(8);
                        doc.setTextColor(120, 120, 120);
                        doc.text('Official School Logo', (pageWidth - doc.getTextWidth('Official School Logo')) / 2, yPos - 5);
                        doc.setTextColor(0, 0, 0); // Reset text color
                    }
                } catch (logoError) {
                    console.log('Logo could not be added:', logoError);
                    // Continue without logo if there's an error
                }
            }
            
            // Add decorative line if logo was added
            if (logoAdded) {
                doc.setDrawColor(200, 200, 200);
                doc.setLineWidth(0.5);
                doc.line(leftMargin + 20, yPos - 5, pageWidth - leftMargin - 20, yPos - 5);
                yPos += 10;
            }
            
            // If no logo was added, add some spacing for visual balance
            if (!logoAdded) {
                yPos += 20;
            }
            
            // School Name
            doc.setFontSize(20);
            doc.setFont(undefined, 'bold');
            const schoolNameForHeader = schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0].schoolname : 'SCHOOL NAME';
            const schoolNameWidth = doc.getTextWidth(schoolNameForHeader);
            doc.text(schoolNameForHeader, (pageWidth - schoolNameWidth) / 2, yPos);
            yPos += 15;
            
            doc.setFontSize(16);
            doc.text('STUDENT ADMISSION FORM', (pageWidth - doc.getTextWidth('STUDENT ADMISSION FORM')) / 2, yPos);
            yPos += 10;
            
            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');
            doc.text(`Academic Year: ${new Date().getFullYear()}-${new Date().getFullYear() + 1}`, (pageWidth - doc.getTextWidth(`Academic Year: ${new Date().getFullYear()}-${new Date().getFullYear() + 1}`)) / 2, yPos);
            yPos += 20;
            
            // Section 1: Student's Personal Details
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.setFillColor(240, 240, 240);
            doc.rect(leftMargin, yPos - 5, pageWidth - 40, 8, 'F');
            doc.text('STUDENT\'S PERSONAL DETAILS', leftMargin + 5, yPos);
            yPos += 15;
            
            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');
            
            // Surname and Other Names
            doc.text('Surname:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 40);
            doc.text('Other Names:', leftMargin + 80, yPos - 5);
            yPos = addUnderlinedField(leftMargin + 110, yPos - 5, 60);
            yPos += 10;
            
            // Date of Birth and Gender
            doc.text('Date of Birth:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 30);
            doc.text('Gender:', leftMargin + 80, yPos - 5);
            let checkboxX = leftMargin + 110;
            checkboxX = addCheckbox(checkboxX, yPos - 5, 'Male');
            checkboxX = addCheckbox(checkboxX, yPos - 5, 'Female');
            yPos += 10;
            
            // Place of Birth
            doc.text('Place of Birth:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 80);
            yPos += 10;
            
            // Nationality and Religion
            doc.text('Nationality:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 30);
            doc.text('Religion:', leftMargin + 80, yPos - 5);
            yPos = addUnderlinedField(leftMargin + 110, yPos - 5, 30);
            yPos += 10;
            
            // Current Address
            doc.text('Current Address:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 80);
            yPos += 10;
            
            // Hometown and Region
            doc.text('Hometown:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 30);
            doc.text('Region:', leftMargin + 80, yPos - 5);
            yPos = addUnderlinedField(leftMargin + 110, yPos - 5, 30);
            yPos += 10;
            
            // Housing Type
            doc.text('Housing Type:', leftMargin, yPos);
            checkboxX = leftMargin + 30;
            checkboxX = addCheckbox(checkboxX, yPos, 'Day Student');
            checkboxX = addCheckbox(checkboxX, yPos, 'Boarding Student');
            yPos += 15;
            
            // Check if we need a new page
            if (yPos > 250) {
                doc.addPage();
                yPos = 20;
            }
            
            // Section 2: Parent/Guardian Details
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.setFillColor(240, 240, 240);
            doc.rect(leftMargin, yPos - 5, pageWidth - 40, 8, 'F');
            doc.text('PARENT/GUARDIAN DETAILS', leftMargin + 5, yPos);
            yPos += 15;
            
            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');
            
            // Father's details
            doc.text('Father\'s Name:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 80);
            yPos += 10;
            
            doc.text('Father\'s Occupation:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 40);
            doc.text('Contact:', leftMargin + 80, yPos - 5);
            yPos = addUnderlinedField(leftMargin + 110, yPos - 5, 30);
            yPos += 10;
            
            doc.text('Father\'s Email:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 80);
            yPos += 10;
            
            doc.text('Father\'s Address:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 80);
            yPos += 10;
            
            // Mother's details
            doc.text('Mother\'s Name:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 80);
            yPos += 10;
            
            doc.text('Mother\'s Occupation:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 40);
            doc.text('Contact:', leftMargin + 80, yPos - 5);
            yPos = addUnderlinedField(leftMargin + 110, yPos - 5, 30);
            yPos += 10;
            
            doc.text('Mother\'s Email:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 80);
            yPos += 10;
            
            doc.text('Mother\'s Address:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 80);
            yPos += 10;
            
            // Emergency Contact
            doc.text('Emergency Contact Person:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 60);
            doc.text('Relationship:', leftMargin + 100, yPos - 5);
            yPos = addUnderlinedField(leftMargin + 130, yPos - 5, 30);
            yPos += 10;
            
            doc.text('Emergency Contact Number:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 30);
            yPos += 15;
            
            // Check if we need a new page
            if (yPos > 250) {
                doc.addPage();
                yPos = 20;
            }
            
            // Section 3: Academic & Enrollment Details
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.setFillColor(240, 240, 240);
            doc.rect(leftMargin, yPos - 5, pageWidth - 40, 8, 'F');
            doc.text('ACADEMIC & ENROLLMENT DETAILS', leftMargin + 5, yPos);
            yPos += 15;
            
            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');
            
            // Previous School
            doc.text('Previous School (if any):', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 80);
            yPos += 10;
            
            // Previous Class and Year
            doc.text('Previous Class:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 30);
            doc.text('Year Completed:', leftMargin + 80, yPos - 5);
            yPos = addUnderlinedField(leftMargin + 110, yPos - 5, 30);
            yPos += 10;
            
            // Admission Class and Date
            doc.text('Admission Class:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 30);
            doc.text('Admission Date:', leftMargin + 80, yPos - 5);
            yPos = addUnderlinedField(leftMargin + 110, yPos - 5, 30);
            yPos += 10;
            
            // Student ID and Special ID
            doc.text('Student ID Number:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 30);
            doc.text('Special ID:', leftMargin + 80, yPos - 5);
            yPos = addUnderlinedField(leftMargin + 110, yPos - 5, 30);
            yPos += 10;
            
            // Academic Level
            doc.text('Academic Level:', leftMargin, yPos);
            checkboxX = leftMargin + 30;
            checkboxX = addCheckbox(checkboxX, yPos, 'Nursery');
            checkboxX = addCheckbox(checkboxX, yPos, 'Primary');
            checkboxX = addCheckbox(checkboxX, yPos, 'JHS');
            checkboxX = addCheckbox(checkboxX, yPos, 'SHS');
            yPos += 15;
            
            // Check if we need a new page
            if (yPos > 250) {
                doc.addPage();
                yPos = 20;
            }
            
            // Section 4: Medical & Health Information
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.setFillColor(240, 240, 240);
            doc.rect(leftMargin, yPos - 5, pageWidth - 40, 8, 'F');
            doc.text('MEDICAL & HEALTH INFORMATION', leftMargin + 5, yPos);
            yPos += 15;
            
            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');
            
            // Blood Group
            doc.text('Blood Group:', leftMargin, yPos);
            checkboxX = leftMargin + 30;
            checkboxX = addCheckbox(checkboxX, yPos, 'A+');
            checkboxX = addCheckbox(checkboxX, yPos, 'A-');
            checkboxX = addCheckbox(checkboxX, yPos, 'B+');
            checkboxX = addCheckbox(checkboxX, yPos, 'B-');
            yPos += 10;
            
            checkboxX = leftMargin + 30;
            checkboxX = addCheckbox(checkboxX, yPos, 'AB+');
            checkboxX = addCheckbox(checkboxX, yPos, 'AB-');
            checkboxX = addCheckbox(checkboxX, yPos, 'O+');
            checkboxX = addCheckbox(checkboxX, yPos, 'O-');
            yPos += 15;
            
            // Medical fields
            doc.text('Allergies (if any):', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 80);
            yPos += 10;
            
            doc.text('Medical Conditions:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 80);
            yPos += 10;
            
            doc.text('Medications:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 80);
            yPos += 15;
            
            // Check if we need a new page
            if (yPos > 250) {
                doc.addPage();
                yPos = 20;
            }
            
            // Section 5: Financial & Documentation
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.setFillColor(240, 240, 240);
            doc.rect(leftMargin, yPos - 5, pageWidth - 40, 8, 'F');
            doc.text('FINANCIAL & DOCUMENTATION', leftMargin + 5, yPos);
            yPos += 15;
            
            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');
            
            // Tuition Fee and Payment Plan
            doc.text('Tuition Fee:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 30);
            doc.text('Payment Plan:', leftMargin + 80, yPos - 5);
            checkboxX = leftMargin + 110;
            checkboxX = addCheckbox(checkboxX, yPos - 5, 'Daily');
            checkboxX = addCheckbox(checkboxX, yPos - 5, 'Weekly');
            checkboxX = addCheckbox(checkboxX, yPos - 5, 'Monthly');
            checkboxX = addCheckbox(checkboxX, yPos - 5, 'Termly');
            yPos += 15;
            
            // Scholarship
            doc.text('Scholarship/Bursary:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 30);
            doc.text('Percentage:', leftMargin + 80, yPos - 5);
            yPos = addUnderlinedField(leftMargin + 110, yPos - 5, 30);
            yPos += 15;
            
            // Documents Required
            doc.text('Documents Required:', leftMargin, yPos);
            yPos += 10;
            checkboxX = leftMargin + 30;
            checkboxX = addCheckbox(checkboxX, yPos, 'Birth Certificate');
            checkboxX = addCheckbox(checkboxX, yPos, 'Previous Report Card');
            yPos += 10;
            checkboxX = leftMargin + 30;
            checkboxX = addCheckbox(checkboxX, yPos, 'Immunization Record');
            checkboxX = addCheckbox(checkboxX, yPos, 'Passport Photos');
            yPos += 10;
            checkboxX = leftMargin + 30;
            checkboxX = addCheckbox(checkboxX, yPos, 'Transfer Letter');
            yPos += 15;
            
            // Check if we need a new page
            if (yPos > 250) {
                doc.addPage();
                yPos = 20;
            }
            
            // Photo Placeholder
            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');
            doc.text('Student Photo (3.5cm x 4.5cm)', (pageWidth - doc.getTextWidth('Student Photo (3.5cm x 4.5cm)')) / 2, yPos);
            yPos += 10;
            
            // Draw photo placeholder box
            const photoWidth = 35;
            const photoHeight = 45;
            const photoX = (pageWidth - photoWidth) / 2;
            doc.setDrawColor(200, 200, 200);
            doc.setFillColor(249, 249, 249);
            doc.rect(photoX, yPos, photoWidth, photoHeight, 'FD');
            doc.setFontSize(8);
            doc.setFont(undefined, 'normal');
            doc.setTextColor(150, 150, 150);
            doc.text('Please attach recent', (pageWidth - doc.getTextWidth('Please attach recent')) / 2, yPos + photoHeight / 2 - 5);
            doc.text('passport photograph', (pageWidth - doc.getTextWidth('passport photograph')) / 2, yPos + photoHeight / 2 + 5);
            doc.setTextColor(0, 0, 0);
            yPos += photoHeight + 15;
            
            // Section 6: Declarations & Signatures
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.setFillColor(240, 240, 240);
            doc.rect(leftMargin, yPos - 5, pageWidth - 40, 8, 'F');
            doc.text('DECLARATIONS & SIGNATURES', leftMargin + 5, yPos);
            yPos += 15;
            
            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');
            
            // Declaration
            doc.text('I declare that the information provided is true and accurate:', leftMargin, yPos);
            checkboxX = leftMargin + 30;
            addCheckbox(checkboxX, yPos, 'Yes');
            yPos += 15;
            
            // Signatures
            doc.text('Parent/Guardian Signature:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 50);
            doc.text('Date:', leftMargin + 90, yPos - 5);
            yPos = addUnderlinedField(leftMargin + 110, yPos - 5, 30);
            yPos += 10;
            
            doc.text('Student Signature (if applicable):', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 50);
            doc.text('Date:', leftMargin + 90, yPos - 5);
            yPos = addUnderlinedField(leftMargin + 110, yPos - 5, 30);
            yPos += 10;
            
            doc.text('Admission Officer Signature:', leftMargin, yPos);
            yPos = addUnderlinedField(leftMargin + 30, yPos, 50);
            doc.text('Date:', leftMargin + 90, yPos - 5);
            yPos = addUnderlinedField(leftMargin + 110, yPos - 5, 30);
            yPos += 15;
            
            // Important Notes
            doc.setFontSize(11);
            doc.setFont(undefined, 'bold');
            doc.text('Important Notes:', leftMargin, yPos);
            yPos += 10;
            
            doc.setFontSize(9);
            doc.setFont(undefined, 'normal');
            const notes = [
                'All fields marked with lines must be completed',
                'Please check appropriate boxes for multiple choice questions',
                'Attach all required documents',
                'This form must be submitted to the school administration',
                'For office use only: Application No. ________________'
            ];
            
            notes.forEach(note => {
                doc.text('• ' + note, leftMargin + 5, yPos);
                yPos += 6;
            });
            
            yPos += 10;
            
            // Footer
            doc.setFontSize(8);
            doc.setTextColor(100, 100, 100);
            doc.text(`Form Generated on: ${new Date().toLocaleDateString()}`, leftMargin, yPos);
            yPos += 5;
            
            const schoolContact = schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0].contact || 'N/A' : 'N/A';
            doc.text(`School Contact: ${schoolContact}`, leftMargin, yPos);
            yPos += 5;
            
            const schoolEmail = schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0].email || 'N/A' : 'N/A';
            doc.text(`School Email: ${schoolEmail}`, leftMargin, yPos);
            
            // Generate filename with school name
            const schoolNameForFile = schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0].schoolname : 'School';
            const filename = `Admission Form for ${schoolNameForFile}.pdf`;
            
            // Save the PDF
            doc.save(filename);
            
            // Show success message
            handleClicksnack();
            setmessage("Admission form PDF downloaded successfully");
            setstated("success");
            
        } catch (error) {
            console.error('Error generating PDF:', error);
            handleClicksnack();
            setmessage("Error generating PDF. Please try again.");
            setstated("error");
        }
    };

    const handleClosenotify = () => {
        setOpennotify(false);
    };

    const handleClickOpensupply = (data) => {
        if(!schooldetails_ || schooldetails_.length === 0 || !schooldetails_[0]?.payment || schooldetails_[0].payment.length === 0 || schooldetails_[0].payment[schooldetails_[0].payment.length-1].amount === "trial" ){

            settrialmode(true)

        }else{
        setchosen(data)
        setpersonclass(data.class_)
        setOpensupply(true);
        }
    };

    const handleClosesupply = () => {
        setOpensupply(false);
    };

    const totalsupplied = (data) => {
        var total = 0
        for (var i in data) {
            total += data[i].quantity
        }


        return total
    }

    const srvrec = (data) => {
        var total = 0
        for (var i in data) {
            total += data[i].SRVrec
        }


        return total
    }

    const imagehandler = (e) => {
        const reader = new FileReader()
        reader.onload = () => {
            if (reader.readyState === 2) {
                setperson(reader.result)
            }
        }

        reader.readAsDataURL(e.target.files[0])
    }

    const handleChange = (event) => {
        setAge(event.target.value);
    };
       
    const handleChangesortclass = (event) => {
        setsortclass(event.target.value);
        setexportdata([])
    };

    // Update exportdata whenever filtered rows change
    useEffect(() => {
        // Convert filtered rows to export format
        const exportData = rows.map((row, index) => ({
            'S/N': index + 1,
            'Student ID': row.id || '',
            'Last Name': row.lastname || '',
            'Other Names': row.othernames || '',
            'Status': row.status || '',
            'Class': row.class_ || '',
            'Gender': row.gender || '',
            'Date of Birth': row.dob || '',
            'Hometown': row.hometown || '',
            'Residence': row.residence || '',
            'Religion': row.religion || '',
            'Guardian Name': row.guardianlastname || '',
            'Guardian Contact': row.guardiancontact || '',
            'Guardian Email': row.guardianemail || '',
            'Special ID': row.specialID || '',
            'Next Class': row.nextclass || '',
            'Housing': row.housing || ''
        }));
        setexportdata(exportData);
    }, [rows]);

    // Export to Excel function
    const handleExportToExcel = () => {
        if (exportdata.length === 0) {
            handleClicksnack();
            setmessage("No data to export");
            setstated("error");
            return;
        }

        try {
            // Create a new workbook
            const wb = Xlsx.utils.book_new();
            
            // Convert exportdata to worksheet
            const ws = Xlsx.utils.json_to_sheet(exportdata);
            
            // Set column widths for better readability
            const colWidths = [
                { wch: 5 },   // S/N
                { wch: 12 },  // Student ID
                { wch: 15 },  // Last Name
                { wch: 15 },  // Other Names
                { wch: 10 },  // Status
                { wch: 10 },  // Class
                { wch: 8 },   // Gender
                { wch: 12 },  // Date of Birth
                { wch: 15 },  // Hometown
                { wch: 20 },  // Residence
                { wch: 12 },  // Religion
                { wch: 15 },  // Guardian Name
                { wch: 15 },  // Guardian Contact
                { wch: 25 },  // Guardian Email
                { wch: 12 },  // Special ID
                { wch: 12 },  // Next Class
                { wch: 10 }   // Housing
            ];
            ws['!cols'] = colWidths;
            
            // Add worksheet to workbook
            Xlsx.utils.book_append_sheet(wb, ws, "Students");
            
            // Generate filename with current date
            const filename = `Students_Export_${new Date().toISOString().split('T')[0]}.xlsx`;
            
            // Write and download the file
            Xlsx.writeFile(wb, filename);
            
            handleClicksnack();
            setmessage("Data exported to Excel successfully");
            setstated("success");
        } catch (error) {
            console.error("Export error:", error);
            handleClicksnack();
            setmessage("Error exporting data to Excel");
            setstated("error");
        }
    };

    // Generate and download Excel template for import
    const handleDownloadTemplate = () => {
        try {
            // Create template data with headers matching backend expected format
            // Column order must match: [0]lastname, [1]othernames, [2]class_, [3]gender, [4]dob, [5]hometown, [6]residence,
            // [7]motherlastname, [8]motherothernames, [9]motheroccupation, [10]mothercontact, [11]motheremail, [12]motherresidence,
            // [13]fatherlastname, [14]fatherothernames, [15]fatheroccupation, [16]fathercontact, [17]fatheremail, [18]fatherresidence,
            // [19]guardianlastname, [20]guardianothernames, [21]guardianoccupation, [22]guardianresidence, [23]guardianemail, [24]guardianrelationship, [25]guardiancontact,
            // [26]balance, [27]totalfees
            const templateData = [
                // Header row - these must match the backend column order exactly
                [
                    'Last Name',
                    'Other Names',
                    'Class',
                    'Gender',
                    'Date of Birth (MM/DD/YYYY)',
                    'Hometown',
                    'Residence',
                    'Mother Last Name',
                    'Mother Other Names',
                    'Mother Occupation',
                    'Mother Contact',
                    'Mother Email',
                    'Mother Residence',
                    'Father Last Name',
                    'Father Other Names',
                    'Father Occupation',
                    'Father Contact',
                    'Father Email',
                    'Father Residence',
                    'Guardian Last Name',
                    'Guardian Other Names',
                    'Guardian Occupation',
                    'Guardian Residence',
                    'Guardian Email',
                    'Guardian Relationship',
                    'Guardian Contact',
                    'Balance',
                    'Total Fees'
                ],
                // Example row (can be removed or kept as guide)
                [
                    'Doe',
                    'John',
                    'JHS 1',
                    'Male',
                    '01/15/2010',
                    'Accra',
                    'Accra',
                    'Doe',
                    'Jane',
                    'Teacher',
                    '0244123456',
                    'jane.doe@email.com',
                    'Accra',
                    'Doe',
                    'John',
                    'Engineer',
                    '0244987654',
                    'john.doe@email.com',
                    'Accra',
                    'Smith',
                    'Mary',
                    'Nurse',
                    'Kumasi',
                    'mary.smith@email.com',
                    'Aunt',
                    '0244111222',
                    '0',
                    '500'
                ]
            ];

            // Create workbook
            const wb = Xlsx.utils.book_new();
            const ws = Xlsx.utils.aoa_to_sheet(templateData);
            
            // Set column widths for better readability
            const colWidths = [
                { wch: 15 }, { wch: 15 }, { wch: 12 }, { wch: 10 }, { wch: 20 },
                { wch: 15 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 },
                { wch: 15 }, { wch: 25 }, { wch: 20 }, { wch: 15 }, { wch: 15 },
                { wch: 15 }, { wch: 15 }, { wch: 25 }, { wch: 20 }, { wch: 15 },
                { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 25 }, { wch: 15 },
                { wch: 15 }, { wch: 12 }, { wch: 12 }
            ];
            ws['!cols'] = colWidths;
            
            // Style header row (bold)
            const headerRange = Xlsx.utils.decode_range(ws['!ref']);
            for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
                const cellAddress = Xlsx.utils.encode_cell({ r: 0, c: col });
                if (!ws[cellAddress]) continue;
                ws[cellAddress].s = {
                    font: { bold: true },
                    fill: { fgColor: { rgb: "E0E0E0" } }
                };
            }
            
            // Add worksheet to workbook
            Xlsx.utils.book_append_sheet(wb, ws, "Student Template");
            
            // Generate filename
            const filename = `Student_Import_Template_${new Date().toISOString().split('T')[0]}.xlsx`;
            
            // Download the file
            Xlsx.writeFile(wb, filename);
            
            handleClicksnack();
            setmessage("Template downloaded successfully");
            setstated("success");
        } catch (error) {
            console.error("Template download error:", error);
            handleClicksnack();
            setmessage("Error downloading template");
            setstated("error");
        }
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = rows.map((n) => n._id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleChange_gender = (e) => {
        setselectedgender(e.target.value)
    }

    const handleChange_religion = (e) => {
        setselectedreligion(e.target.value)
    }

    const handleChange_class = (e) => {
        setselectedclass(e.target.value)
    }

    const handleChange_genderedit = (e) => {
        setselectedgenderedit(e.target.value)
    }

    const handleChange_religionedit = (e) => {
        setselectedreligionedit(e.target.value)
    }

    const handleChange_classedit = (e) => {
        setselectedclassedit(e.target.value)
    }

    const sorting = (e) => {
        
        setsorter(e.target.value)
    }
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };  

    const handleChangeterm = (e) => {
        setselectedterm(e.target.value);
       setattendancedata(e.target.value!=="none"?chosen.attendance[e.target.value]!==undefined?chosen.attendance[e.target.value]:[]:[])
    
    };

    const handleChangepromote = (e) => {
        setselectedpromote(e.target.value);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event) => {
        setDense(event.target.checked);
    };

    const editacademic =(data)=>{

        setwhattype(data)
        setreopendate(chosen.reopendate || '')

    }


   


    const isSelected = (id) => selected.indexOf(id) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

const setback=(data)=>{
    setwhat(data)
}
        const sendmessage = () =>{

            return(

<div style={{textAlign:"center", margin:8}}>
<p style={{textAlign:"center", margin:12}}>
                        Send a message to Guardian via 
                    </p>
                    {/* <Button  style={{backgroundColor:" #e0eff9" , color:"#1976d2", margin:12, padding:10}} startIcon={  <WhatsAppIcon style={{fontSize:"20px"}} />} aria-label="fingerprint"  >
        <small> Whatsapp</small>
      </Button> */}
           <Button style={{backgroundColor:" #e0eff9" , color:"#1976d2", margin:12, padding:10}} startIcon={ <EmailIcon style={{fontSize:"20px"}} />} onClick={()=>setback("email")} aria-label="fingerprint" >
        <small> Email</small>
      </Button>
   <Button style={{backgroundColor:" #e0eff9" , color:"#1976d2", margin:12, padding:10}} startIcon={ <MessageIcon style={{fontSize:"20px"}} />} onClick={()=>setback("sms")} aria-label="fingerprint" >
        <small> Text Message</small>
      </Button>

 

                    
                
</div>

            )
        }

        const viaSMS = ()=>{
            
            return(
                <div style={{textAlign:"left", marginTop:10}}>
                <Button onClick={()=>setback("back")} style={{margin:2}}>
                <KeyboardBackspaceIcon />
                </Button>
                <div style={{textAlign:"center"}}>
                <p style={{textAlign:"center", marginTop:"-30px", fontWeight:'bolder'}}> Sending Message Via SMS</p>
<Divider/>
<br/>
<br/>
                <textarea id='viasms' rows="5" defaultValue={"Hello "+ chosen.guardianlastname} style={{width:"80%", padding:10, borderColor:"grey", borderRadius:"5px"}} />    
<br/>
 {smsloading ===true?
                               <LoadingButton
        loading
        loadingPosition="start"
        startIcon={<SaveIcon />}
        variant="outlined"
      >
        Loading...
      </LoadingButton>:
                          
                                <Button autoFocus onClick={() => sendsms()} style={{backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                                   Send
                                </Button>
                            }
                </div>
                </div>


            )

        }
    

        const viaEmail = ()=>{
            
            return(
                <div style={{textAlign:"left", marginTop:10}}>
                <Button onClick={()=>setback("back")} style={{margin:2}}>
                <KeyboardBackspaceIcon />
                </Button>
                <div style={{textAlign:"center"}}>
                <p style={{textAlign:"center", marginTop:"-30px", fontWeight:'bolder'}}> Sending Message Via Email</p>
<Divider/>
<br/>
<br/>
                <textarea id='emailsubject' rows="1" placeholder='Subject' style={{width:"80%", padding:10, borderColor:"grey", borderRadius:"5px"}} />    
                <textarea id='viaemail' rows="5" defaultValue={"Hello "+ chosen.guardianlastname} style={{width:"80%", padding:10, borderColor:"grey", borderRadius:"5px"}} />    
<br/>

 {emailloading ===true?
                               <LoadingButton
        loading
        loadingPosition="start"
        startIcon={<SaveIcon />}
        variant="outlined"
      >
        Loading...
      </LoadingButton>:
                          
                                <Button autoFocus onClick={() => sendemail()} style={{backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                                    Send
                                </Button>
                            }
                </div>
                </div>


            )

        }

        const viaEmailandtext = ()=>{
            
            return(
                <div style={{textAlign:"left", marginTop:10}}>
                <Button style={{margin:2}}>
                <KeyboardBackspaceIcon />
                </Button>
                <div style={{textAlign:"center"}}>
                <p style={{textAlign:"center", marginTop:"-30px", fontWeight:'bolder'}}> Sending Message Via Email and SMS</p>
<Divider/>
<br/>
<br/>
                <textarea rows="5" defaultValue="Hello Mr. Ntori" style={{width:"80%", padding:10, borderColor:"grey", borderRadius:"5px"}} />    

                </div>
                </div>


            )

        }

    
        const messenger =(type)=>{
    if(type==="email"){
        return(
            viaEmail()
        )
    }
    if(type==="sms"){
        return(
            viaSMS()
        )
    }  if(type==="back"){
        return(
            sendmessage()
        )
    }
        }


        const mainrecord =()=>{
            var data=[]
            if(selectedterm !== "none" && chosen.length!==0){
            data=chosen.academic.filter(bug=> bug.term === selectedterm)

            }
return(
    <div> 

<DialogTitle id="customized-dialog-title" onClose={handleClosesupply} style={{  }}>
                
                        <FormControl style={{ marginLeft:45, marginRight:5, backgroundColor:" #e0eff9" , color:"#1976d2" }}>
                        <InputLabel id="demo-simple-select-autowidth-label">Term</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id=""
                            value={selectedterm}
                            style={{ minWidth: 200, padding: 0, margin: 0 }}
                            onChange={(e)=>handleChangeterm(e)}
                            autoWidth
                            label="Term"
                            size="small"
                        >
                            <MenuItem value="none">
                                <em>Choose Term</em>
                            </MenuItem>
                            {schooldetails_ && schooldetails_.length > 0 && schooldetails_[0]?.terms && schooldetails_[0].terms.length > 0 ?
                            schooldetails_ && schooldetails_[0] && schooldetails_[0].terms && schooldetails_[0].terms.map((list,index)=>
                            <MenuItem key={index} value={list}>{list}</MenuItem>

                            ) :""   
                        }
                          
                        </Select>
                    </FormControl>
                    <Button onClick={()=>editacademic("edit")} style={{marginLeft:10,backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                    Add / Edit Results
                    </Button>

                    <Button onClick={handleClosesupply} style={{float:"right"}}> close </Button>
      
                    <Button  onClick={handlesendresults} style={{marginLeft:10,backgroundColor:" #e0eff9" , color:"#1976d2"}}>Send to Guardian</Button>

                    <Button  onClick={()=>editacademic("reopen")}  style={{marginLeft:10,backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                        set re-opening date
                    </Button>

                </DialogTitle>

                <DialogContent dividers style={{ textAlign: "left" }}>

                    <Printpage data={chosen} term={selectedterm} Class_={Class_} students={rows} schooldata={schooldetails_}/>

                </DialogContent>

    </div> 
)

        }


        const positions = (term, data, id,classname) => {
var list = []
var list2 = [data]
var position = "None"
var arrange = []
var value = 0
    for(var i in rows){
        if(rows[i]._id !== id){
        if(rows[i].academic.length !==0){

            console.log(rows[i])

        for(var k in rows[i].academic){
            if(rows[i].academic[k].term===term && rows[i].class_===classname){
               list.push(rows[i].academic[k].totalscore) 
            }
        }
        }
    }

    }
    
    for(var i in list){
        if (list2.includes(list[i])){
        console.log("includes")
        }else(
            list2.push(list[i])
        )
        
    }

    list2= list2.sort((a,b)=>b-a)

    for(var i in list2){
        var sum = parseInt(i)+1
         if((sum).toString()[(sum).toString().length-1] === "1"){
        arrange.push({score:list2[i], position:(sum).toString()+"st"})

    } else if((sum).toString()[(sum).toString().length-1] === "2"){
         arrange.push({score:list2[i], position:(sum).toString()+"nd"})
    }
    else if((sum).toString()[(sum).toString().length-1] === "3"){
        arrange.push({score:list2[i], position:(sum).toString()+"rd"})

    }else{
        arrange.push({score:list2[i], position:(sum).toString()+"th"})
    }
    }


 const doposition = async () => {
            await axiosInstance.post("https://servermain.sisrevolution.com/api/students/arrangepositions/",
                {
                    class_: chosen.class_,
                    term: term,
                    data: arrange,
                    schoolID:admin.schoolID
          
                }).then(res => {

                    if (res.status === 200) {

                       
                        
                        // setloading(!true)
                        // handleClosesupply()
                        // handleClicksnack()
                        // setmessage("You have successfully added to supply list")
                        // setstated("success")
                       

                        
                    } else {
                        // setloading(!true)
                        // handleClosesupply()
                        // handleClicksnack()
                        // setmessage("Error adding to supply list")
                        // setstated("error")

                    }

                })

        }

        doposition()



   
    value = list2.findIndex(bug=>bug===data) + 1
    console.log(value.toString()[value.toString().length-1])
    if(value.toString()[value.toString().length-1] === "1"){
        position=value.toString()+"st"

    } else if(value.toString()[value.toString().length-1] === "2"){
        position=value.toString()+"nd"

    }
    else if(value.toString()[value.toString().length-1] === "3"){
        position=value.toString()+"rd"

    }else{
        position=value.toString()+"th"
    }



    return position

        }

        const editrecord =()=>{

            var subjected = Class_.filter(bug=>bug.classname === chosen.class_)
            console.log(subjected)
            var number = subjected[0].subjects[0]
            var results = []
            var conclusion = []
            var totalscore=0
            var aggregatecalc=[]
            var aggregate=0
            var elective=0
            var core=0
            //var promotion = document.getElementById('nextclass').value
            var promotion = selectedpromote
            
            if(promotion === "none"){
                 promotion=chosen.class_
            }

            const submitscore=async()=>{
                var interest =  document.getElementById("interest").value
                var conduct =  document.getElementById("conduct").value
                var teacherremarks =  document.getElementById("teacherremarks").value
                var headremarks =  document.getElementById("headremarks").value

                setloading(true)
                const classInfo = Array.isArray(Class_) ? Class_.find((bug) => bug.classname === chosen.class_) : null;
                const classGrades = Array.isArray(classInfo?.grades) ? classInfo.grades : [];
                const schoolGrades = schooldetails_ && schooldetails_[0]?.grades ? schooldetails_[0].grades : [];
                let activeGrades = classGrades.length !== 0 ? classGrades : schoolGrades;

                if (classGrades.length === 0 && schoolGrades.length !== 0 && classInfo?._id) {
                    try {
                        await axiosInstance.post("https://servermain.sisrevolution.com/api/class/updategrading/", {
                            _id: classInfo._id,
                            grades: schoolGrades,
                            schoolID: admin.schoolID
                        });
                        activeGrades = schoolGrades;
                    } catch (err) {
                        // Continue with fallback grades even if class sync request fails
                    }
                }

if(activeGrades && activeGrades.length!==0){
                // Helpers for customized grading on special exams
                const getSpecialExamPercent = (specialExamScore) => {
                    if (!specialExamScore || typeof specialExamScore !== 'string') return null;
                    const parts = specialExamScore.split('/');
                    if (parts.length !== 2) return null;
                    const obtained = parseFloat(parts[0]);
                    const total = parseFloat(parts[1]);
                    if (isNaN(obtained) || isNaN(total) || total <= 0) return null;
                    return (obtained / total) * 100;
                };
                
                const getGradeAndRemarkFromCustomScale = (percentScore) => {
                    const grades_ = Array.isArray(activeGrades) ? activeGrades : [];
                    if (!grades_.length || percentScore === null || percentScore === undefined) {
                        return { grade: '', remark: '' };
                    }
                    const match = grades_.find((g) => {
                        const upper = parseFloat(g?.upperlimit);
                        const lower = parseFloat(g?.lowerlimit);
                        if (isNaN(upper) || isNaN(lower)) return false;
                        const max = Math.max(upper, lower);
                        const min = Math.min(upper, lower);
                        return percentScore <= max && percentScore >= min;
                    });
                    return {
                        grade: match?.grade || match?.grades || '',
                        remark: match?.remarks || ''
                    };
                };
                for(var i in number){
                    var subjectType = subjected[0].subjects[0][i].type || '';
                    var isSpecialExam = subjectType.toLowerCase().trim() === 'special exams' || subjectType.toLowerCase().trim() === 'special exam';
                    
                    if(isSpecialExam){
                        // Handle special exam: get special exam score in "obtained/total" format
                        var specialExamElement = document.getElementById('specialexam'+subjected[0].subjects[0][i].subject+i);
                        var specialExamScore = specialExamElement ? specialExamElement.value : '';
                        
                        // Validate format
                        if(specialExamScore && !/^\d+\/\d+$/.test(specialExamScore)){
                            setloading(!true);
                            handleClicksnack();
                            setmessage("Special exam score must be in format 'obtained/total' (e.g., 30/40)");
                            setstated("error");
                            return;
                        }
                        
                        // For special exams, compute scaled percent and derive grade/remark from custom scale
                        const specialPercent = getSpecialExamPercent(specialExamScore);
                        const specialScale = getGradeAndRemarkFromCustomScale(specialPercent);
                        // Do not add to aggregate or total, but persist grade/remarks for special exams section
                        results.push({
                            subject: subjected[0].subjects[0][i].subject, 
                            class_scorre: 0, 
                            exam_score: 0, 
                            total: 0, 
                            grade: specialScale.grade || '', 
                            remarks: specialScale.remark || '',
                            specialExamScore: specialExamScore,
                            specialExamPercent: specialPercent
                        });
                    } else {
                        // Handle regular subject
                    var classscore = document.getElementById('class'+subjected[0].subjects[0][i].subject+i).value
                    var examscore =  document.getElementById('exams'+subjected[0].subjects[0][i].subject+i).value
                    
                    if(classscore===""){
                        classscore = 0
                    }  
                    if(examscore===""){
                        examscore = 0
                    }
                    
                   var total =(parseInt(classscore)+parseInt(examscore))
                   totalscore += total
                   const regularScale = getGradeAndRemarkFromCustomScale(total)
                   aggregatecalc.push([regularScale.grade || "F",subjected[0].subjects[0][i].type])
                   results.push({subject: subjected[0].subjects[0][i].subject, class_scorre: classscore, exam_score:examscore, total:total , grade:regularScale.grade || "F", remarks:regularScale.remark || "Fail" })
                    }
                }
               
            
                for(var i in aggregatecalc){
                    
                if(aggregatecalc[i][1]==="Core" && core < 5){     
                    aggregate += parseInt(aggregatecalc[i])
                    core+=core+1
                }
               
                var sorter = aggregatecalc.filter(bug=>bug[1]==="Elective")
                var filtervalue = []
                for (var u in sorter){
                    filtervalue.push(parseInt(sorter[u]))
                }
                filtervalue.sort((x,y)=>x-y)
                
                
                if(elective < 4){
                    aggregate += parseInt(filtervalue[i])
                    // console.log("elective aggregate" +i)
                    elective+=elective+1
                }
               
            }

    conclusion = {term:selectedterm, position:positions(selectedterm, totalscore, chosen._id, chosen.class_ ), results:results, totalscore:totalscore, promotion:promotion, interest:interest, conduct:conduct, teacherremarks:teacherremarks, headremarks:headremarks,  aggregate:aggregate}

    const doerresult = async () => {
            await axiosInstance.post("https://servermain.sisrevolution.com/api/students/addresults/",
                {
                    id: chosen._id,
                    data: conclusion,
                    term: selectedterm,
                    class_: promotion,
                    schoolID:admin.schoolID

                }).then(res => {

                    if (res.status === 200) {

                    //    gettingdata()
                        
                        setloading(!true)
                        handleClosesupply()
                        handleClicksnack()
                        setmessage("You have successfully added academic records")
                        setstated("success")
                                            
                    } else {
                        setloading(!true)
                        handleClosesupply()
                        handleClicksnack()
                        setmessage("Error adding academic records")
                        setstated("error")

                    }

                })

        }

        try{
        doerresult()
        }catch(err){
            setloading(!true)
            handleClicksnack()

                        setmessage("Network Error")
                        setstated("error")
        }

    }else{
        handlenotify()
    }
            }
        



    return(
    <div> 

<DialogTitle id="customized-dialog-title" onClose={handleClosesupply} style={{  }}>
   <Button style={{margin:2}} onClick={()=>editacademic("back")}>
                <KeyboardBackspaceIcon />
                </Button>
                   Add / Edit Academic records

                     <FormControl style={{ marginLeft:10, marginRight:0 }}>
                        <InputLabel id="demo-simple-select-autowidth-label">{terminology}</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id=""
                            value={selectedterm}
                            style={{ minWidth: 200, padding: 0, margin: 0 }}
                            onChange={(e)=>handleChangeterm(e)}
                            autoWidth
                            label={terminology}
                            size="small"
                        >
                            <MenuItem value="none">
                                <em>Choose {terminology}</em>
                            </MenuItem>
                            {termOptions.map((option, index) => (
                                <MenuItem key={index} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                  
                    <Button onClick={handleClosesupply} style={{float:"right"}}>
                    close
                    </Button>
                </DialogTitle>

                <DialogContent dividers style={{ textAlign: "left" }}>
                  <ListItem align="left">
                                                    <ListItemAvatar>
                                                        <Avatar src={getStudentThumbnailUrl(chosen) || undefined} size="small" alt={chosen.lastname+" "+ chosen.othernames} onClick={() => handleClickOpenimage(chosen)} style={{cursor:"pointer"}} imgProps={{
                                                            onError: (e) => {
                                                                const full = getStudentFullImageUrl(chosen);
                                                                if (full && e.currentTarget.src !== full) {
                                                                    e.currentTarget.src = full;
                                                                    return;
                                                                }
                                                                e.currentTarget.removeAttribute('src');
                                                            }
                                                        }}>
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText primary={chosen.lastname+" "+ chosen.othernames}  />
                                                </ListItem>
                    
               <FormControl style={{ marginLeft:0, marginRight:0, marginTop:10, marginBottom:10 }}>
                        <InputLabel id="demo-simple-select-autowidth-label">Promoted to</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id=""
                            value={selectedpromote}
                            style={{ minWidth: 200, padding: 0, margin: 0 }}
                            onChange={(e)=>handleChangepromote(e)}
                            autoWidth
                            label="Promoted to"
                            size="small"
                        >
                            <MenuItem value="none">
                                <em>Promoted to</em>
                            </MenuItem>   
                            <MenuItem value="Repeat">
                                <em>Repeat</em>
                            </MenuItem>

                            {Class_ && Class_.map((row, index)=>
                            <MenuItem value={row.classname}>{row.classname}</MenuItem>

                            )}
                         

                        </Select>
                    </FormControl>
                   
                    <TableContainer component={Paper}>
      <Table sx={{ minWidth: "100%" }} aria-label="simple table">
        <TableHead>
          <TableRow>
                      <TableCell>SUBJECTS</TableCell>
                      <TableCell align="left">CLASS SCORE (50%)</TableCell>
                      <TableCell align="left">EXAM SCORE (50%)</TableCell>
                      <TableCell align="left">SPECIAL EXAMS</TableCell>
                      

          </TableRow>
        </TableHead>
        <TableBody>
         { chosen.academic.length===0 ? subjected[0].subjects[0].map((row, index) => {
            const isSpecialExam = row.type && (row.type.toLowerCase().trim() === 'special exams' || row.type.toLowerCase().trim() === 'special exam');
            return (
            <TableRow
                  key={row.subject}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
             
                  <TableCell align="left">{row.subject}</TableCell>
                  {isSpecialExam ? (
                    <>
                      <TableCell align="left" style={{display: 'none'}}></TableCell>
                      <TableCell align="left" style={{display: 'none'}}></TableCell>
                      <TableCell align="left">
                        <input 
                          id={'specialexam'+row.subject+index} 
                          placeholder="e.g., 30/40"
                          style={{borderRadius:"5px", padding:"10px", border:"solid", borderWidth:"0.3px", borderColor:"grey", width:"100%" }} 
                          type="text"
                          pattern="\d+/\d+"
                        />
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell align="left">
                        <input  
                          id={'class'+row.subject+index} 
                          style={{borderRadius:"5px", padding:"10px", border:"solid", borderWidth:"0.3px", borderColor:"grey" }} 
                          type="number"
                        />
                      </TableCell>
                      <TableCell align="left">
                        <input 
                          id={'exams'+row.subject+index}   
                          style={{borderRadius:"5px", padding:"10px", border:"solid", borderWidth:"0.3px", borderColor:"grey" }} 
                          type="number"
                        />
                      </TableCell>
                      <TableCell align="left" style={{display: 'none'}}></TableCell>
                    </>
                  )}

            </TableRow>
          )})
          : (chosen.academic.filter(bug=> bug.term === selectedterm).length !==0 ?
            chosen.academic.filter(bug=> bug.term === selectedterm)[0].results.map((row,index)=> {
              // Find subject type from class subjects
              const subjectInfo = subjected[0]?.subjects[0]?.find(s => s.subject === row.subject);
              const isSpecialExam = subjectInfo?.type && (subjectInfo.type.toLowerCase().trim() === 'special exams' || subjectInfo.type.toLowerCase().trim() === 'special exam');
              const specialExamValue = row.specialExamScore || '';
              
              return (
            <TableRow
                  key={row.subject}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                                
                  <TableCell align="left">{row.subject}</TableCell>
                  {isSpecialExam ? (
                    <>
                      <TableCell align="left" style={{display: 'none'}}></TableCell>
                      <TableCell align="left" style={{display: 'none'}}></TableCell>
                      <TableCell align="left">
                        <input 
                          id={'specialexam'+row.subject+index} 
                          defaultValue={specialExamValue}
                          placeholder="e.g., 30/40"
                          style={{borderRadius:"5px", padding:"10px", border:"solid", borderWidth:"0.3px", borderColor:"grey", width:"100%" }} 
                          type="text"
                          pattern="\d+/\d+"
                        />
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell align="left">
                        <input  
                          id={'class'+row.subject+index} 
                          defaultValue={row.class_scorre} 
                          style={{borderRadius:"5px", padding:"10px", border:"solid", borderWidth:"0.3px", borderColor:"grey" }} 
                          type="number"
                        />
                      </TableCell>
                      <TableCell align="left">
                        <input 
                          id={'exams'+row.subject+index}  
                          defaultValue={row.exam_score}   
                          style={{borderRadius:"5px", padding:"10px", border:"solid", borderWidth:"0.3px", borderColor:"grey" }} 
                          type="number"
                        />
                      </TableCell>
                      <TableCell align="left" style={{display: 'none'}}></TableCell>
                    </>
                  )}

            </TableRow>
          )})
            :
            subjected[0].subjects[0].map((row, index) => {
              const isSpecialExam = row.type && (row.type.toLowerCase().trim() === 'special exams' || row.type.toLowerCase().trim() === 'special exam');
              return (
                <TableRow
                      key={row.subject}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                      <TableCell align="left">{row.subject}</TableCell>
                      {isSpecialExam ? (
                        <>
                          <TableCell align="left" style={{display: 'none'}}></TableCell>
                          <TableCell align="left" style={{display: 'none'}}></TableCell>
                          <TableCell align="left">
                            <input 
                              id={'specialexam'+row.subject+index} 
                              placeholder="e.g., 30/40"
                              style={{borderRadius:"5px", padding:"10px", border:"solid", borderWidth:"0.3px", borderColor:"grey", width:"100%" }} 
                              type="text"
                              pattern="\d+/\d+"
                            />
                          </TableCell>
                        </>
                      ) : (
                        <>
                          <TableCell align="left">
                            <input  
                              id={'class'+row.subject+index} 
                              style={{borderRadius:"5px", padding:"10px", border:"solid", borderWidth:"0.3px", borderColor:"grey" }} 
                              type="number"
                            />
                          </TableCell>
                          <TableCell align="left">
                            <input 
                              id={'exams'+row.subject+index}   
                              style={{borderRadius:"5px", padding:"10px", border:"solid", borderWidth:"0.3px", borderColor:"grey" }} 
                              type="number"
                            />
                          </TableCell>
                          <TableCell align="left" style={{display: 'none'}}></TableCell>
                        </>
                      )}
    
                </TableRow>
              )
            })
          )
          }
        </TableBody>
      </Table>

      <FormControl variant="standard" style={{ margin: 10 }}>
      {/* <InputLabel id="interest">Interest</InputLabel> */}

<TextField
labelId="interest"
    id="interest"
    placeholder="Interest"
    type="text"
    className="signup"
    variant="outlined"
    defaultValue={chosen.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm).length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm)[0].interest !==undefined? chosen.academic.filter(bug=> bug.term === selectedterm)[0].interest :""}
    size="small"


/>
</FormControl>

      <FormControl variant="standard" style={{ margin: 10 }}>
      {/* <InputLabel id="conduct">Conduct</InputLabel> */}

<TextField
labelId="conduct"
    id="conduct"
    placeholder="Conduct / Character"
    type="text"
    className="signup"
    variant="outlined"
    defaultValue={chosen.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm).length!==0 &&  chosen.academic.filter(bug=> bug.term === selectedterm)[0].conduct!==undefined ? chosen.academic.filter(bug=> bug.term === selectedterm)[0].conduct:""}
    size="small"


/>
</FormControl>

      <FormControl variant="standard" style={{ margin: 10 }}>
      {/* <InputLabel id="remark">Teacher's Remarks</InputLabel> */}

<TextField
labelId="remark"
    id="teacherremarks"
    placeholder="Class Teacher's Remarks"
    type="text"
    className="signup"
    variant="outlined"
    defaultValue={chosen.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm).length!==0 &&  chosen.academic.filter(bug=> bug.term === selectedterm)[0].teacherremarks !== undefined ? chosen.academic.filter(bug=> bug.term === selectedterm)[0].teacherremarks:""}
    size="small"


/>
</FormControl>

      <FormControl variant="standard" style={{ margin: 10 }}>
      {/* <InputLabel id="head">Headteacher's Remarks</InputLabel> */}

<TextField
labelId="head"
    id="headremarks"
    placeholder="Headteacher's Remarks"
    type="text"
    className="signup"
    variant="outlined"
    defaultValue={chosen.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm).length!==0 &&  chosen.academic.filter(bug=> bug.term === selectedterm)[0].headremarks!== undefined ? chosen.academic.filter(bug=> bug.term === selectedterm)[0].headremarks:""}
    size="small"


/>
</FormControl>

    </TableContainer>
<br/>
    {loading ===true?
    <div align="center"> 
                               <LoadingButton
        loading
        loadingPosition="start"
        startIcon={<SaveIcon />}
        variant="outlined"
      >
        Loading...
      </LoadingButton>
      </div>:
                          
                          <div align="center">   <Button autoFocus onClick={() => submitscore()} style={{backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                                    Submit
                                </Button></div>
                            }


                </DialogContent>



    </div> 
    )
        }  
        
                
        const reopen=()=>{
          

            const submitdate=()=>{
                setloading(true)

                const dodate = async () => {
                    await axiosInstance.post("https://servermain.sisrevolution.com/api/schools/changereopendate/",
                        {
                            _id: schooldetails_ && schooldetails_.length > 0 ? schooldetails_[0]._id : '',
                            reopendate: reopendate,
        
                        }).then(res => {
        
                            if (res.status === 200) {
        
                                if (res.data) {
                                    dispatch(schooldetails({

                                        data: [res.data]
                    
                                    }))
                                }
                                
                                setloading(!true)
                                handleClosesupply()
                                handleClicksnack()
                                setmessage("You have successfully Changed Re-opening Date")
                                setstated("success")
                               
        
                                
                            } else {
                                setloading(!true)
                                handleClosesupply()
                                handleClicksnack()
                                setmessage("Error changing re-opening date")
                                setstated("error")
        
                            }
        
                        })
        
                }
        
                try{
                dodate()
                }catch(err){
                    setloading(!true)
                    handleClicksnack()

                    setmessage("Network Error")
                    setstated("error")
                }
              
            }
       
    return(
    <div> 

<DialogTitle id="customized-dialog-title" onClose={handleClosesupply} style={{  }}>
   <Button style={{margin:2}} onClick={()=>editacademic("back")}>
                <KeyboardBackspaceIcon />
                </Button>
                    Set Re-Opening Date                  
                    <Button onClick={handleClosesupply} style={{float:"right"}}>
                    close
                    </Button>
                </DialogTitle>

                <DialogContent dividers style={{ textAlign: "center" }}>
                 
                <FormControl variant="standard" style={{ margin: 10, textAlign:"center" }}>

<TextField
    id="reopendate"
    placeholder="Re-Opening Date"
    type="date"
    className="signup"
    variant="outlined"
    value={reopendate}
    onChange={(e)=>setreopendate(e.target.value)}
    // label="Re-Opening Date"
    size="small"



/>
</FormControl>
                   
{loading ===true?
    <div align="center"> 
                               <LoadingButton
        loading
        loadingPosition="start"
        startIcon={<SaveIcon />}
        variant="outlined"
      >
        Loading...
      </LoadingButton>
      </div>:
                           <div align="center"> 
                                <Button autoFocus onClick={() => submitdate()} style={{backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                                   Set Date
                                </Button>
                                </div>
                            }           



                </DialogContent>



    </div> 
    )
        }

        const records =(recordtype)=>{
    if(recordtype==="edit"){
        return(
            editrecord()
        )
    }   
    if(recordtype==="reopen"){
        return(
            reopen()
        )
    }
     if(recordtype==="back"){
        return(
            mainrecord()
        )
    }
        }

        const guardianchange =(e)=>{

            setGuardian(e.target.value)

        } 

        const saveClassGradeFromPrepareDialog = async () => {
            const upperlimit = document.getElementById("prep_upperlimit")?.value;
            const lowerlimit = document.getElementById("prep_lowerlimit")?.value;
            const grade = document.getElementById("prep_grade")?.value;
            const gradepoint = document.getElementById("prep_gradepoint")?.value;
            const remarks_ = document.getElementById("prep_remarks")?.value;

            const activeClassName = chosen?.class_ || "";
            const classInfo = (Array.isArray(Class_) ? Class_ : []).find((c) => c.classname === activeClassName);

            if (!classInfo?._id) {
                handleClicksnack();
                setmessage("Select a student/class first");
                setstated("error");
                return;
            }

            if (upperlimit === "" || lowerlimit === "") {
                handleClicksnack();
                setmessage("Enter upper and lower limits");
                setstated("error");
                return;
            }

            const currentGrades = Array.isArray(classInfo.grades) ? classInfo.grades : [];
            const newGrade = {
                id: new Date().toISOString(),
                upperlimit,
                lowerlimit,
                grade,
                gradepoint,
                remarks: remarks_
            };
            const updatedGrades = [...currentGrades, newGrade];

            try {
                const res = await axiosInstance.post("https://servermain.sisrevolution.com/api/class/updategrading/", {
                    _id: classInfo._id,
                    schoolID: admin.schoolID,
                    grades: updatedGrades
                });
                if (res.status === 200) {
                    dispatch(getdata_({ data: res.data }));
                    handleClicksnack();
                    setmessage("Grading scale saved to class");
                    setstated("success");
                    handleClosenotify();
                } else {
                    handleClicksnack();
                    setmessage("Error saving grading scale");
                    setstated("error");
                }
            } catch (err) {
                handleClicksnack();
                setmessage("Network error while saving grading scale");
                setstated("error");
            }
        }
         const admissionchange =(e)=>{

            setAdmission(e.target.value)

        } 
        
        const guardianchangeedit =(e)=>{

            setguardianedit(e.target.value)

        }

        const otherguardian = () =>{


            return(

                <div>

<p style={{textAlign:"center"}}>Fill this if Guardian is not a parent </p>

<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="guardian-surname-field"
    id="surname"
    placeholder="Surname"
    type="text"
    className="signup"
    variant="outlined"
    
    size="small"


/>
</FormControl>
<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="guardian-othernames-field"
    id="othernames"
    placeholder="Other name(s)"
    type="text"
   
    className="signup"
    variant="outlined"
    label="Othername(s)"
    size="small"



/>
</FormControl>
<br />


<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="guardian-occupation-field"
    id="occupation"
    placeholder="Occupation"
    type="text"
   
    className="signup"
    variant="outlined"
    label="Occupation"
    size="small"



/>
</FormControl>
<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="guardian-contact-field"
    id="contact"
    placeholder="Contact"
    type="tel"

    className="signup"
    variant="outlined"
    label="Contact"
    size="small"



/>
</FormControl>
<br />


<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="guardian-email-field"
    id="email"
    placeholder="Email"
    type="email"
    
    className="signup"
    variant="outlined"
    label="Email"
    size="small"



/>
</FormControl>
<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="guardian-address-field"
    id="address"
    placeholder="Address"
    type="address"

    className="signup"
    variant="outlined"
    label="Address"
    size="small"



/>
</FormControl>
<br />

                </div>
            )

        }

        const otherguardianedit = () =>{


            return(

                <div>

<p style={{textAlign:"center"}}>Fill this if Guardian is not a parent </p>

<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="guardianlastnameedit-field"
    id="guardianlastnameedit"
    placeholder="Surname"
    type="text"
    className="signup"
    variant="outlined"
    defaultValue={chosen.guardianlastname}
    size="small"


/>
</FormControl>
<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="guardianothernamesedit-field"
    id="guardianothernamesedit"
    placeholder="Other name(s)"
    type="text"
    defaultValue={chosen.guardianothernames}
    className="signup"
    variant="outlined"
    label="Othername(s)"
    size="small"



/>
</FormControl>
<br />


<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="guardianoccupationedit-field"
    id="guardianoccupationedit"
    placeholder="Occupation"
    type="text"
    defaultValue={chosen.guardianoccupation}
    className="signup"
    variant="outlined"
    label="Occupation"
    size="small"

/>
</FormControl>
<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="guardiancontactedit-field"
    id="guardiancontactedit"
    placeholder="Contact"
    type="tel"
    defaultValue={chosen.guardiancontact}
    className="signup"
    variant="outlined"
    label="Contact"
    size="small"



/>
</FormControl>
<br />


<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="guardianemailedit-field"
    id="guardianemailedit"
    placeholder="Email"
    type="email"
    defaultValue={chosen.guardianemail}
    className="signup"
    variant="outlined"
    label="Email"
    size="small"



/>
</FormControl>
<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="guardianresidenceedit-field"
    id="guardianresidenceedit"
    placeholder="Address"
    type="address"
    defaultValue={chosen.guardianresidence}
    className="signup"
    variant="outlined"
    label="Address"
    size="small"



/>
</FormControl>
<br />

                </div>
            )

        }

        // This logic is now handled in changestudenttype function

        const changestudenttype=(e, name)=>{
            setexportdata([])
            console.log(e.target.checked)
            if(name==="Active"){
                setactivestudents(e.target.checked)
                if(e.target.checked) {
                setwithdrawnstudents(false)
                setcompletestudents(false)
                }
            }
             else if(name==="Completed"){
                setcompletestudents(e.target.checked)
                if(e.target.checked) {
                setactivestudents(false)
                setwithdrawnstudents(false)
                }
            }   
            else if(name==="Withdrawn"){
                setwithdrawnstudents(e.target.checked)
                if(e.target.checked) {
                    setactivestudents(false)
                setcompletestudents(false) 
                }
            }

            // Ensure at least one switch is always checked
            if(!e.target.checked && !activestudents && !withdrawnstudents && !completestudents) {
                setactivestudents(true)
            }
        }
           
        const status_changer=(e)=>{
            setstatus_selector(e.target.value)
        }


        const settrialmode_=()=>{
            settrialmode(false)
        }


    // Show loading state if school details are not loaded
    if (!schooldetails_ || schooldetails_.length === 0) {
        return (
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                <CircularProgress />
                <Typography sx={{ ml: 2 }}>Loading school details...</Typography>
            </Box>
        );
    }

    return (

        <Box sx={{ width: '100%' }}>

            <Snackbar open={opensnack} autoHideDuration={6000} onClose={handleClosesnack}>
                <Alert onClose={handleClosesnack} severity={stated} sx={{ width: '100%' }}>
                    { message }
                </Alert>
            </Snackbar>

            <Dialog maxWidth="md" onClose={handleClosenotify} aria-labelledby="customized-dialog-title" open={opennotify}>
                <DialogTitle id="customized-dialog-title" onClose={handleClosenotify} style={{ backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)", color: "white" }}>
                    Customize Grading Scale
                    <IconButton onClick={handleClosenotify} style={{float:"right"}}><CloseIcon style={{color:"white"}}/></IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <p>Class: <b>{chosen?.class_ || "-"}</b></p>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TextField id="prep_upperlimit" label="Upper Limit" type="number" fullWidth size="small" />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField id="prep_lowerlimit" label="Lower Limit" type="number" fullWidth size="small" />
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="prep-grade-label">Grade</InputLabel>
                                <Select labelId="prep-grade-label" id="prep_grade" label="Grade" defaultValue="A">
                                    <MenuItem value="A+">A+</MenuItem>
                                    <MenuItem value="A">A</MenuItem>
                                    <MenuItem value="A-">A-</MenuItem>
                                    <MenuItem value="B+">B+</MenuItem>
                                    <MenuItem value="B">B</MenuItem>
                                    <MenuItem value="C">C</MenuItem>
                                    <MenuItem value="D">D</MenuItem>
                                    <MenuItem value="E">E</MenuItem>
                                    <MenuItem value="F">F</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="prep-gradepoint-label">Grade Point</InputLabel>
                                <Select labelId="prep-gradepoint-label" id="prep_gradepoint" label="Grade Point" defaultValue="1">
                                    <MenuItem value="1">1</MenuItem>
                                    <MenuItem value="2">2</MenuItem>
                                    <MenuItem value="3">3</MenuItem>
                                    <MenuItem value="4">4</MenuItem>
                                    <MenuItem value="5">5</MenuItem>
                                    <MenuItem value="6">6</MenuItem>
                                    <MenuItem value="7">7</MenuItem>
                                    <MenuItem value="8">8</MenuItem>
                                    <MenuItem value="9">9</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="prep-remarks-label">Remarks</InputLabel>
                                <Select labelId="prep-remarks-label" id="prep_remarks" label="Remarks" defaultValue="Excellent">
                                    <MenuItem value="Distinction">Distinction</MenuItem>
                                    <MenuItem value="Excellent">Excellent</MenuItem>
                                    <MenuItem value="Very Good">Very Good</MenuItem>
                                    <MenuItem value="Good">Good</MenuItem>
                                    <MenuItem value="Credit">Credit</MenuItem>
                                    <MenuItem value="Pass">Pass</MenuItem>
                                    <MenuItem value="Fail">Fail</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div style={{ marginTop: 12 }}>
                        <div style={{ fontSize: 12, color: "#666", marginBottom: 6 }}>
                            Source: <b>{(Array.isArray(Class_) && (Class_.find(c => c.classname === (chosen?.class_ || ""))?.grades || []).length > 0) ? `Class (${chosen?.class_ || "-"})` : "School (fallback)"}</b>
                        </div>
                        {(() => {
                            const classInfoPrepare = Array.isArray(Class_) ? Class_.find(c => c.classname === (chosen?.class_ || "")) : null;
                            const classGradesPrepare = Array.isArray(classInfoPrepare?.grades) ? classInfoPrepare.grades : [];
                            const schoolGradesPrepare = Array.isArray(schooldetails_?.[0]?.grades) ? schooldetails_[0].grades : [];
                            const activeGradesPrepare = classGradesPrepare.length > 0 ? classGradesPrepare : schoolGradesPrepare;
                            if (activeGradesPrepare && activeGradesPrepare.length > 0) {
                                return (
                                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                                        <thead>
                                            <tr>
                                                <th style={{ border: "1px solid #e0e0e0", padding: 6 }}>Upper</th>
                                                <th style={{ border: "1px solid #e0e0e0", padding: 6 }}>Lower</th>
                                                <th style={{ border: "1px solid #e0e0e0", padding: 6 }}>Grade</th>
                                                <th style={{ border: "1px solid #e0e0e0", padding: 6 }}>Point</th>
                                                <th style={{ border: "1px solid #e0e0e0", padding: 6 }}>Remarks</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {activeGradesPrepare.map((g, i) => (
                                                <tr key={g.id || i}>
                                                    <td style={{ border: "1px solid #f0f0f0", padding: 6 }}>{g.upperlimit}</td>
                                                    <td style={{ border: "1px solid #f0f0f0", padding: 6 }}>{g.lowerlimit}</td>
                                                    <td style={{ border: "1px solid #f0f0f0", padding: 6 }}>{g.grade || g.gradepoint}</td>
                                                    <td style={{ border: "1px solid #f0f0f0", padding: 6 }}>{g.gradepoint}</td>
                                                    <td style={{ border: "1px solid #f0f0f0", padding: 6 }}>{g.remarks || g.remark}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )
                            }
                            return (<div style={{ fontSize: 12, color: "#999" }}>No grading scale configured yet.</div>)
                        })()}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClosenotify}>Cancel</Button>
                    <Button variant="contained" onClick={saveClassGradeFromPrepareDialog}>Save Grading Scale</Button>
                </DialogActions>
            </Dialog>

            <Dialog maxWidth="lg" onClose={handleClosedelete} aria-labelledby="customized-dialog-title" open={opendelete}>
 <DialogTitle id="customized-dialog-title" onClose={handleClosedelete} style={{ backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)"
, color: "white" }}>
                    Delete
                    <IconButton onClick={handleClosedelete} style={{float:"right"}}><CloseIcon style={{color:"white"}}/></IconButton>
                </DialogTitle>
                <DialogContent dividers>

                    <p>
                        Are you sure you want to delete {chosen.lastname+" "+chosen.othernames} from the database?
                    </p>

                </DialogContent>
                <DialogActions>

 {deletestudentloading ===true?
                               <LoadingButton
        loading
        loadingPosition="start"
        startIcon={<SaveIcon />}
        variant="outlined"
      >
        Loading...
      </LoadingButton>:
                          
                                <Button autoFocus onClick={() => deleter()} style={{backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                                    Submit
                                </Button>
                            }


                 

                    <Button autoFocus onClick={handleClosedelete} style={{backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                        No
                    </Button>
                </DialogActions>
            </Dialog>



            <Dialog fullWidth maxWidth="sm" onClose={handleCloseresults} aria-labelledby="customized-dialog-title" open={openresults}>
 <DialogTitle id="customized-dialog-title" onClose={handleCloseresults} style={{ backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)"
, color: "white" }}>
                    Send Results To Guardian
                    <IconButton onClick={handleCloseresults} style={{float:"right"}}><CloseIcon style={{color:"white"}}/></IconButton>
                </DialogTitle>
            <br/>
            <DialogContent>
                <FormControl style={{ width: '100%', marginBottom: '20px' }}>
                    <InputLabel id="term-select-label">Select Term</InputLabel>
                    <Select
                        labelId="term-select-label"
                        value={selectedterm}
                        onChange={(e) => setselectedterm(e.target.value)}
                        label="Select Term"
                        style={{ width: '100%' }}
                    >
                        <MenuItem value="none">
                            <em>Choose Term</em>
                        </MenuItem>
                        {schooldetails_ && schooldetails_.length > 0 && schooldetails_[0]?.terms && schooldetails_[0].terms.length > 0?
                            schooldetails_[0].terms.map((list,index)=>
                                <MenuItem key={index} value={list}>{list}</MenuItem>
                            ) : ""   
                        }
                    </Select>
                </FormControl>
                
                <FormControl component="fieldset" style={{ width: '100%', marginBottom: '20px' }}>
                    <FormLabel component="legend" style={{ marginBottom: '10px', fontWeight: 600 }}>Select Results to Send:</FormLabel>
                    <RadioGroup
                        value={resultsFilter}
                        onChange={(e) => setResultsFilter(e.target.value)}
                        style={{ paddingLeft: '10px' }}
                    >
                        <FormControlLabel value="all" control={<Radio />} label="All Records" />
                        <FormControlLabel value="specialExams" control={<Radio />} label="Only Special Exams" />
                        <FormControlLabel value="excludeSpecialExams" control={<Radio />} label="All Except Special Exams" />
                    </RadioGroup>
                </FormControl>
            </DialogContent>
            <br/>
            <Grid container textAlign="center">
                <Grid xs={6}>
                {loadingguardian ===true?
   
   <LoadingButton
loading
loadingPosition="start"
startIcon={<SaveIcon />}
variant="outlined"
style={{marginLeft:10}}
>
Loading...
</LoadingButton>
:

<Button  onClick={()=>sendviatext(chosen)} style={{marginLeft:10,backgroundColor:" #e0eff9" , color:"#1976d2"}}>Send results via sms</Button>

}
</Grid>

<Grid xs={6}>

{loadingemail ===true?
   
   <LoadingButton
loading
loadingPosition="start"
startIcon={<SaveIcon />}
variant="outlined"
style={{marginLeft:10}}
>
Loading...
</LoadingButton>
:

<Button  onClick={()=>sendviaemail(chosen)} style={{marginLeft:10,backgroundColor:" #e0eff9" , color:"#1976d2"}}>Send results via email</Button>

}

</Grid>

</Grid>
<br/>
<br/>

            </Dialog>

            <Dialog maxWidth="lg" onClose={settrialmode_} aria-labelledby="customized-dialog-title" open={trialmode}>
 <DialogTitle id="customized-dialog-title" onClose={settrialmode_}  style={{ backgroundColor: "gray", color: "white" }}>
                    Trial Mode
                    <IconButton onClick={settrialmode_}  style={{float:"right"}}><CloseIcon style={{color:"white"}}/></IconButton>
                </DialogTitle>
                <DialogContent dividers>

                    <p>

                    You are on a trial mode, go to pricing and settle payment in order to use this function.

                    </p>

                </DialogContent>
                <DialogActions>

                   <Link to="/pricing"><Button autoFocus  style={{backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                        Pricing
                    </Button>
                    </Link> 
                </DialogActions>
            </Dialog>

            <Dialog maxWidth="lg" onClose={handleClosestatus} aria-labelledby="customized-dialog-title" open={openstatus}>
 <DialogTitle id="customized-dialog-title" onClose={handleClosestatus} style={{ backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)"
, color: "white" }}>
                    Change Student Status
                    <IconButton onClick={handleClosestatus} style={{float:"right"}}><CloseIcon style={{color:"white"}}/></IconButton>
                </DialogTitle>
                <DialogContent dividers>

                  
                <FormControl>
      {/* <FormLabel id="demo-radio-buttons-group-label">Status</FormLabel> */}
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        value={status_selector}
        onChange={status_changer}
        name="radio-buttons-group"
      >
        <FormControlLabel value="Active" control={<Radio />} label="Active" />
        <FormControlLabel value="Completed" control={<Radio />} label="Completed" />
        <FormControlLabel value="Withdrawn" control={<Radio />} label="Withdrawn" />
      </RadioGroup>
    </FormControl>


                </DialogContent>
                <DialogActions>

 {deletestudentloading ===true?
                               <LoadingButton
        loading
        loadingPosition="start"
        startIcon={<SaveIcon />}
        variant="outlined"
      >
        Loading...
      </LoadingButton>:
                          
                                <Button autoFocus onClick={() => changestatus()} style={{backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                                    Submit
                                </Button>
                            }

                </DialogActions>
            </Dialog>

            <Dialog fullWidth maxWidth="sm" onClose={handleClosemessage} aria-labelledby="customized-dialog-title" open={openmessage}>
             <DialogTitle id="customized-dialog-title" onClose={handleCloseattendance} style={{ backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)"
, color: "white" }}>
                    Messages
                    <IconButton onClick={handleClosemessage} style={{float:"right"}}><CloseIcon style={{color:"white"}}/></IconButton>
                </DialogTitle>
                {messenger(what)}
            
                <DialogActions>

                    <Button>
                    
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog fullWidth maxWidth="md" onClose={handleClosetranscript} aria-labelledby="customized-dialog-title" open={opentranscript}>
                <DialogTitle id="customized-dialog-title" onClose={handleClosetranscript} style={{ backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)"
, color: "white" }}>
                    Generate Student Transcript
                    <IconButton onClick={handleClosetranscript} style={{float:"right"}}><CloseIcon style={{color:"white"}}/></IconButton>
                </DialogTitle>
                <DialogContent dividers style={{textAlign:"center"}}>
                    <div style={{margin: "20px 0"}}>
                        <h3 style={{color: "#1976d2", marginBottom: "20px"}}>
                            Generate Transcript for {chosen.lastname} {chosen.othernames}
                        </h3>
                        <p style={{marginBottom: "20px", color: "#666"}}>
                            Select the terms you want to include in the transcript:
                        </p>
                        
                        <FormControl style={{ margin: "20px 0", minWidth: 300 }}>
                            <InputLabel id="transcript-terms-label">Select Terms</InputLabel>
                            <Select
                                labelId="transcript-terms-label"
                                multiple
                                value={selectedtranscriptterms}
                                onChange={(e) => setselectedtranscriptterms(e.target.value)}
                                renderValue={(selected) => selected.join(', ')}
                                label="Select Terms"
                            >
                                {schooldetails_ && schooldetails_.length > 0 && schooldetails_[0]?.terms && schooldetails_[0].terms.length > 0 ?
                                    schooldetails_ && schooldetails_[0] && schooldetails_[0].terms && schooldetails_[0].terms.map((term, index) => (
                                        <MenuItem key={index} value={term}>
                                            {term}
                                        </MenuItem>
                                    )) : 
                                    <MenuItem disabled>No terms available</MenuItem>
                                }
                            </Select>
                            <div style={{marginTop: "8px", fontSize: "12px", color: "#666"}}>
                                {selectedtranscriptterms.length > 0 ? 
                                    `Selected ${selectedtranscriptterms.length} term(s): ${selectedtranscriptterms.join(', ')}` : 
                                    'Please select at least one term to generate transcript'
                                }
                            </div>
                        </FormControl>
                        
                        <div style={{margin: "20px 0"}}>
                            {selectedtranscriptterms.length > 0 && (
                                <div style={{marginBottom: "15px", padding: "10px", background: "#fff3cd", border: "1px solid #ffeaa7", borderRadius: "5px", fontSize: "14px"}}>
                                    <strong>Note:</strong> Only terms with available academic records will be included in the transcript.
                                </div>
                            )}
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={selectedtranscriptterms.length === 0}
                                onClick={() => {
                                    generateTranscript(chosen, selectedtranscriptterms);
                                }}
                                style={{
                                    padding: '12px 24px',
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    borderRadius: '8px',
                                    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.2)',
                                }}
                            >
                                Generate Transcript
                            </Button>
                        </div>
                        
                        <div style={{margin: "20px 0", padding: "15px", background: "#f0f8ff", borderRadius: "8px", borderLeft: "4px solid #1976d2"}}>
                            <h4 style={{color: "#1976d2", marginBottom: "10px"}}>What's Included:</h4>
                            <ul style={{textAlign: "left", color: "#666"}}>
                                <li>Student personal information and photo</li>
                                <li>Academic performance for selected terms</li>
                                <li>Subject-wise scores and grades</li>
                                <li>Position and aggregate information</li>
                                <li>Promotion status</li>
                                <li>Guardian contact details</li>
                            </ul>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog fullWidth maxWidth="sm" onClose={handleCloseattendance} aria-labelledby="customized-dialog-title" open={openattendance}>
                <DialogTitle id="customized-dialog-title" onClose={handleCloseattendance} style={{ backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)"
, color: "white" }}>
                    Attendance
                    <IconButton onClick={handleCloseattendance} style={{float:"right"}}><CloseIcon style={{color:"white"}}/></IconButton>
                </DialogTitle>
                <DialogContent dividers style={{textAlign:"center"}}>
                                        <FormControl style={{ marginRight:5 }}>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id=""
                            value={selectedterm}
                            style={{ minWidth: 200, padding: 0, margin: 0 }}
                            onChange={(e)=>handleChangeterm(e)}
                            autoWidth
                            size="small"
                        >
                            <MenuItem value="none">
                                <em>Choose Term</em>
                            </MenuItem>
                            {schooldetails_ && schooldetails_.length > 0 && schooldetails_[0]?.terms && schooldetails_[0].terms.length > 0 ?
                            schooldetails_ && schooldetails_[0] && schooldetails_[0].terms && schooldetails_[0].terms.map((list,index)=>
                            <MenuItem key={index} value={list}>{list}</MenuItem>

                            ) :""   
                        }
                        </Select>
                    </FormControl>
                    <br/>
                    <h2 ><span style={{color:"blue"}}>{chosen.length !== 0 && selectedterm!=="none"  ? chosen.attendance.length!==0 && chosen.attendance[selectedterm]!==undefined?chosen.attendance[selectedterm].filter(bug=>bug.attendance==="present").length:0:0}</span> / <span  style={{color:"green"}}>{chosen.length!==0 && selectedterm!=="none"?chosen.attendance[selectedterm]!==undefined?chosen.attendance[selectedterm].length:0:0}</span></h2>

                    <Attendance atendance={attendancedata}/>
                
                    <br/>
                    <br/>
                </DialogContent>
                
            </Dialog>

            <Dialog fullWidth maxWidth="sm" onClose={handleCloseview} aria-labelledby="customized-dialog-title" open={openview}>
               <DialogTitle id="customized-dialog-title" onClose={handleCloseview} style={{ backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)"
, color: "white" }}>
                    Student Information
                    <IconButton onClick={handleCloseview} style={{float:"right"}}><CloseIcon style={{color:"white"}}/></IconButton>
                </DialogTitle>
                <DialogContent dividers>
<div style={{marginLeft:"40%"}}>
<Avatar style={{ width: 100, height: 100, border: "solid", borderColor: "#f0f0f0" }} alt={chosen.lastname} src={getStudentThumbnailUrl(chosen) || undefined} imgProps={{
    onError: (e) => {
        const full = getStudentFullImageUrl(chosen);
        if (full && e.currentTarget.src !== full) {
            e.currentTarget.src = full;
            return;
        }
        e.currentTarget.removeAttribute('src');
    }
}} />
</div>
                    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                        <ListItem>
                            <ListItemText primary={chosen.lastname+" "+chosen.othernames} secondary="Name" />
                        </ListItem>
                        <Divider /> 
                        <ListItem>
                            <ListItemText primary={chosen.id} secondary="Student ID" />
                        </ListItem>
                        <Divider /> 
                        <ListItem>
                            <ListItemText primary={chosen.specialID} secondary="Special ID" />
                        </ListItem>
                        <Divider /> 
                        <ListItem>
                            <ListItemText primary={chosen.index===undefined?"No Index Number":chosen.index} secondary="Index Number" />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <ListItemText primary={chosen.length !==0? (months[parseInt((chosen.dob.split("-"))[1])-1] +" "+(chosen.dob.split("-"))[2]+", "+(chosen.dob.split("-"))[0] ): 0}    secondary="Date Of Birth" />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <ListItemText primary={currencySymbol + " "+chosen.dailycharge} secondary="Daily Charge" />
                        </ListItem>
                        <Divider /> 
                        <ListItem>
                            <ListItemText primary={chosen.gender} secondary="Gender" />
                        </ListItem>
                        <Divider /> 
                        
                        <ListItem>
                            <ListItemText primary={chosen.class_} secondary="Class" />
                        </ListItem>
                        <Divider />  
                        
                        <ListItem>
                            <ListItemText primary={chosen.residence} secondary="Residence" />
                        </ListItem>
                        <Divider />

               
                        <ListItem>
                            <ListItemText primary={chosen.hometown} secondary="Hometown" />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <ListItemText primary={chosen.guardianlastname+" "+chosen.guardianothernames} secondary="Guardian's Name" />
                        </ListItem>
                        <Divider />  
                        <ListItem>
                            <ListItemText primary={chosen.guardianrelationship} secondary="Guardian's Relationship" />
                        </ListItem>
                        <Divider />  
                        <ListItem>
                            <ListItemText primary={chosen.guardiancontact} secondary="Guardian's Contact" />
                        </ListItem>
                        <Divider />    
                        <ListItem>
                            <ListItemText primary={chosen.guardianemail} secondary="Guardian's Email" />
                        </ListItem>
                        <Divider />   
                        <ListItem>
                            <ListItemText primary={chosen.guardianresidence} secondary="Guardian's Address" />
                        </ListItem>
                        <Divider />



                    </List>

                    <br />

                    
                </DialogContent>
              
            </Dialog>

            <Dialog fullWidth maxWidth="lg" onClose={handleClosesupply} aria-labelledby="customized-dialog-title" open={opensupply}>
                
            {records(whattype)}

               
            </Dialog>

            <Dialog fullWidth maxWidth="sm" onClose={handleCloseimage} aria-labelledby="customized-dialog-title" open={openimage}>
                 <DialogTitle id="customized-dialog-title" onClose={handleCloseimage} style={{ backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)"
, color: "white" }}>
                   {chosen.lastname+" "+chosen.othernames}
                    <IconButton onClick={handleCloseimage} style={{float:"right"}}><CloseIcon style={{color:"white"}}/></IconButton>
                </DialogTitle>

                <DialogContent dividers style={{ textAlign: "center" }}>

                       
                 <img src={getStudentFullImageUrl(chosen) || ''} width="100%" alt="" />
                      
                </DialogContent>

            </Dialog>


            <Dialog  maxWidth="md" onClose={handleCloseadd} aria-labelledby="customized-dialog-title" open={openadd}>
                  <DialogTitle id="customized-dialog-title" onClose={handleCloseattendance} style={{ backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)"
, color: "white" }}>
                    New Student
                    <IconButton onClick={handleCloseadd} style={{float:"right"}}><CloseIcon style={{color:"white"}}/></IconButton>
                </DialogTitle>

                    <DialogContent dividers>

                <form>

                        <div style={{ width: "100%", textAlign:"center" }}>



                            <input

                                style={{ display: "none" }}
                                id="fileimage"
                                multiple
                                type="file"
                                onChange={(e) => imagehandler(e)}
                            />
                            <label htmlFor="fileimage">
                                <Badge
                                    overlap="circular"
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                    badgeContent={
                                        <CameraAltIcon style={{ cursor:"pointer", backgroundColor: "darkblue", padding: 6, borderRadius: "100%", color: "white", fontSize: "26px" }} />
                                    }
                                >
                                    <Avatar style={{ width: 100, height: 100, border: "solid", borderColor: "#f0f0f0" }} alt="Travis Howard" src={person} />

                                </Badge>

                            </label>

                           
                        </div>
                        <br />

                        <Divider><small> <b>STUDENT'S PERSONAL DETAILS </b></small></Divider>
                    <br/>

                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="lastname-field"
                                id="lastname"
                                placeholder="Surname"
                                type="text"
                                className="signup"
                                variant="outlined"
                                label="Surname"
                                size="small"



                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="othernames-field"
                                id="othernames"
                                placeholder="Other name(s)"
                                type="text"
                                className="signup"
                                variant="outlined"
                                label="Othername(s)"
                                size="small"



                            />
                        </FormControl>
                        <br />

                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="dob-field"
                                id="dob"
                                label="Date of Birth"
                                type="date"
                                defaultValue="2017-05-24"
                               
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                className="signup"
                                size="small"
                            />
                        </FormControl>

                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="residence-field"
                                id="residence"
                                placeholder="Residence Address"
                                type="address"
                                className="signup"
                                label="Residence Address"
                                size="small"



                            />
                        </FormControl>

                        <br />
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="hometown-field"
                                id="hometown"
                                placeholder="Hometown"
                                type="text"
                                className="signup"
                                variant="outlined"
                                label="Hometown"
                                size="small"



                            />
                        </FormControl>

                        <FormControl style={{ margin: 10 }}>
                            <InputLabel id="demo-simple-select-helper-label">Religion</InputLabel>
                            <Select
                                id="religion"
                                value={selectedreligion}
                                label="Religion"
                                className="signup"
                                variant="outlined"
                                size="small"

                                onChange={handleChange_religion}
                            >

                                <MenuItem value="none"><em>Choose Religion</em></MenuItem>
                                <MenuItem value="Christianity">Christianity</MenuItem>
                                <MenuItem value="Islam">Islam</MenuItem>
                                <MenuItem value="Jainism">Jainism</MenuItem>
                                <MenuItem value="Judaism">Judaism</MenuItem>
                                <MenuItem value="Shinto">Shinto</MenuItem>

                            </Select>


                        </FormControl>

                        <br />

                        <FormControl  style={{ margin: 10 }}>
                            <InputLabel id="demo-simple-select-helper-label">Gender</InputLabel>
                            <Select
                                id="gender"
                                value={selectedgender}
                                label="Gender"
                                className="signup"
                                variant="outlined"
                                size="small"
                                style={{padding:0}}

                                onChange={handleChange_gender}
                            >
                                <MenuItem value="none"><em>Choose Gender</em></MenuItem>
                                <MenuItem value="Male">Male</MenuItem>
                                <MenuItem value="Female">Female</MenuItem>

                            </Select>


                        </FormControl>

                        
                        <FormControl style={{ margin: 10 }}>
                            <InputLabel id="demo-simple-select-helper-label">Class</InputLabel>
                            <Select
                                id="demo-simple-select-helper"
                                value={selectedclass}
                                label="Class"
                                className="signup"
                                variant="outlined"
                                size="small"

                                onChange={handleChange_class}
                            >
                                <MenuItem value="none"> <em>Choose Class</em> </MenuItem>
                              {Class_.length !==0 ? Class_.map((list, index)=>
                                <MenuItem value={list.classname}>{list.classname}</MenuItem>
                                
                                ):""}
                                

                            </Select>


                        </FormControl>

                        <br/>
                        <FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="index-field"
    id="index"
    placeholder="Index Number"
    type="text"
    className="signup"
    variant="outlined"
    label="Index Number"
    size="small"



/>
</FormControl>                 

<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="specialID-field"
    id="specialID"
    placeholder="Special ID"
    type="text"
    className="signup"
    variant="outlined"
    label="Special ID"
    size="small"



/>

</FormControl>
<br/>
<FormControl style={{ margin: 10 }}>
                            <InputLabel id="demo-simple-select-helper-label">Housing</InputLabel>
                            <Select
                                id="housing"
                                value={housing}
                                label="Housing"
                                className="signup"
                                variant="outlined"
                                size="small"

                                onChange={(e)=>sethousing(e.target.value)}
                            >

                                <MenuItem value="Day">Day</MenuItem>
                                <MenuItem value="Boarding">Boarding</MenuItem>
                                

                            </Select>


                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="scholarship-field"
    id="scholarship"
    placeholder="Scholarship Percentage"
    type="number"
    className="signup"
    variant="outlined"
    defaultValue={0}
    label="Scholarship Percentage"
    size="small"
    InputProps={{
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
      }}
/>
</FormControl>
<br/>
<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="dailyfee-field"
    id="dailyfee"
    placeholder="Daily Charges"
    type="number"
    className="signup"
    variant="outlined"
    defaultValue={0}
    label="Daily Charge"
    size="small"
    InputProps={{
        startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment>,
      }}
/>
                    </FormControl>
                    
                    <FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="weeklyfee-field"
    id="weeklyfee"
    placeholder="Weekly Charges"
    type="number"
    className="signup"
    variant="outlined"
    defaultValue={0}
    label="Weekly Charge"
    size="small"
    InputProps={{
        startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment>,
      }}
/>
</FormControl>
<br/>
<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    key="monthlyfee-field"
    id="monthlyfee"
    placeholder="Monthly Charges"
    type="number"
    className="signup"
    variant="outlined"
    defaultValue={0}
    label="Monthly Charge"
    size="small"
    InputProps={{
        startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment>,
      }}
/>
                    </FormControl>
                        <br/>
                        <br/>
                        <Divider><small> <b>STUDENT'S PARENTS DETAILS </b></small></Divider>

                        <p style={{textAlign:"center"}}> <b>Mother</b></p>

                     
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="motherlastname-field"
                                id="motherlastname"
                                placeholder="Surname"
                                type="text"
                                className="signup"
                                variant="outlined"
                                label="Surname"
                                size="small"



                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="motherothernames-field"
                                id="motherothernames"
                                placeholder="Other name(s)"
                                type="text"
                                className="signup"
                                variant="outlined"
                                label="Othername(s)"
                                size="small"



                            />
                        </FormControl>
                        <br />

                      
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="motheroccupation-field"
                                id="motheroccupation"
                                placeholder="Occupation"
                                type="text"
                                className="signup"
                                variant="outlined"
                                label="Occupation"
                                size="small"



                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="mothercontact-field"
                                id="mothercontact"
                                placeholder="Contact"
                                type="tel"
                                className="signup"
                                variant="outlined"
                                label="Contact"
                                size="small"



                            />
                        </FormControl>
                        <br />

                        
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="motheremail-field"
                                id="motheremail"
                                placeholder="Email"
                                type="email"
                                className="signup"
                                variant="outlined"
                                label="Email"
                                size="small"



                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="motherresidence-field"
                                id="motherresidence"
                                placeholder="Address"
                                type="address"
                                className="signup"
                                variant="outlined"
                                label="Address"
                                size="small"



                            />
                        </FormControl>
                        <br />


                        <p style={{ textAlign: "center" }}> <b>Father </b></p>

                    
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="fatherlastname-field"
                                id="fatherlastname"
                                placeholder="Surname"
                                type="text"
                                className="signup"
                                variant="outlined"

                                size="small"


                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="fatherothernames-field"
                                id="fatherothernames"
                                placeholder="Other name(s)"
                                type="text"
                                className="signup"
                                variant="outlined"
                                label="Othername(s)"
                                size="small"



                            />
                        </FormControl>
                        <br />

                      
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="fatheroccupation-field"
                                id="fatheroccupation"
                                placeholder="Occupation"
                                type="text"
                                className="signup"
                                variant="outlined"
                                label="Occupation"
                                size="small"



                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="fathercontact-field"
                                id="fathercontact"
                                placeholder="Contact"
                                type="tel"
                                className="signup"
                                variant="outlined"
                                label="Contact"
                                size="small"

                            />
                        </FormControl>
                        <br />

                        
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="fatheremail-field"
                                id="fatheremail"
                                placeholder="Email"
                                type="email"
                                className="signup"
                                variant="outlined"
                                label="Email"
                                size="small"

                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                key="fatherresidence-field"
                                id="fatherresidence"
                                placeholder="Address"
                                type="address"
                                className="signup"
                                variant="outlined"
                                label="Address"
                                size="small"

                            />
                        </FormControl>
                        <br />
                        <br />
                        <Divider><small> <b>Admission Type </b></small></Divider>
                        <br />

                        <FormControl>
                            <FormLabel id="demo-row-radio-buttons-group-label">Admission Type</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                id="guardianedit"
                                value={admission}
                                onChange={(e)=>admissionchange(e)}
                            >
                                <FormControlLabel value="new" control={<Radio />} label="New Student" />
                                <FormControlLabel value="existing" control={<Radio />} label="Existing Student" />
                                
                            </RadioGroup>
                        </FormControl>

                        <Divider><small> <b>GUARDIAN </b></small></Divider>
                        <br />

                        <FormControl>
                            <FormLabel id="demo-row-radio-buttons-group-label">Guardian Relationship</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                id="guardianedit"
                                value={guardian}
                                onChange={(e)=>guardianchange(e)}
                            >
                                <FormControlLabel value="Mother" control={<Radio />} label="Mother" />
                                <FormControlLabel value="Father" control={<Radio />} label="Father" />
                                <FormControlLabel value="Parents" control={<Radio />} label="Parents" />
                                <FormControlLabel value="Others" control={<Radio />} label="Others" />
                                
                            </RadioGroup>
                        </FormControl>
                        <br/>
                        {guardian === "Others" && 
                        
                        <div>

                        <p style={{textAlign:"center"}}>Fill this if Guardian is not a parent </p>
                        
                        <FormControl variant="standard" style={{ margin: 10 }}>
                        
                        <TextField
                            id="guardianlastname"
                            placeholder="Surname"
                            type="text"
                            className="signup"
                            variant="outlined"
                            
                            size="small"
                        
                        
                        />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>
                        
                        <TextField
                            id="guardianothernames"
                            placeholder="Other name(s)"
                            type="text"
                           
                            className="signup"
                            variant="outlined"
                            label="Othername(s)"
                            size="small"
                        
                        
                        
                        />
                        </FormControl>
                        <br />
                        
                        
                        <FormControl variant="standard" style={{ margin: 10 }}>
                        
                        <TextField
                            id="guardianoccupation"
                            placeholder="Occupation"
                            type="text"
                           
                            className="signup"
                            variant="outlined"
                            label="Occupation"
                            size="small"
                        
                        
                        
                        />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>
                        
                        <TextField
                            id="guardiancontact"
                            placeholder="Contact"
                            type="tel"
                        
                            className="signup"
                            variant="outlined"
                            label="Contact"
                            size="small"
                        
                        
                        
                        />
                        </FormControl>
                        <br />
                        
                        
                        <FormControl variant="standard" style={{ margin: 10 }}>
                        
                        <TextField
                            id="guardianemail"
                            placeholder="Email"
                            type="email"
                            
                            className="signup"
                            variant="outlined"
                            label="Email"
                            size="small"
                        
                        
                        
                        />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>
                        
                        <TextField
                            id="guardianaddress"
                            placeholder="Address"
                            type="address"
                        
                            className="signup"
                            variant="outlined"
                            label="Address"
                            size="small"
                        
                        
                        
                        />
                        </FormControl>
                        <br />
                        
                                        </div>

                        }

                        <br />

                        <div style={{ textAlign: "center" }}>
                           
                           
                        </div>

                        </form>
                    </DialogContent>

                    <DialogActions >
            {newstudentloading ===true?
                               <LoadingButton
        loading
        loadingPosition="start"
        startIcon={<SaveIcon />}
        variant="outlined"
      >
        Loading...
      </LoadingButton>:
                          
                                <Button autoFocus onClick={() => registerstudent()} style={{backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                                    Submit
                                </Button>
                            }


                      
                    </DialogActions>
                </Dialog>



            <Dialog fullWidth maxWidth="md" onClose={handleCloseaddexcel} aria-labelledby="customized-dialog-title" open={openaddexcel}>
                  <DialogTitle id="customized-dialog-title" onClose={handleCloseaddexcel} style={{ backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)"
, color: "white" }}>
                    Import Student Data 
                    <IconButton onClick={handleCloseaddexcel} style={{float:"right"}}><CloseIcon style={{color:"white"}}/></IconButton>
                </DialogTitle>

                    <DialogContent dividers>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            Download the Excel template, fill it with student data, and upload to import into the database.
                        </Typography>
                        <Box sx={{ mb: 3 }}>
                            <Button
                                variant="contained"
                                startIcon={<DownloadIcon />}
                                onClick={handleDownloadTemplate}
                                sx={{ mb: 1 }}
                            >
                                Download Excel Template
                            </Button>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                            Upload Filled Excel File:
                        </Typography>
                        <input 
                            type="file" 
                            accept=".xlsx,.xls"
                            onChange={(e) => readUploadFile(e)}
                            style={{ marginTop: 10, padding: '8px' }}
                        />
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
                            <strong>Note:</strong> Date format should be MM/DD/YYYY (e.g., 01/15/2010)
                        </Typography>
                    </DialogContent>

                    <DialogActions >
            {newstudentloading ===true?
                               <LoadingButton
        loading
        loadingPosition="start"
        startIcon={<SaveIcon />}
        variant="outlined"
      >
        Loading...
      </LoadingButton>:
                          
                                <Button autoFocus onClick={() => uloadsxcel()} style={{backgroundColor:" #e0eff9" , color:"#1976d2"}}>
                                    Import Student Data
                                </Button>
                            }


                      
                    </DialogActions>
                </Dialog>




            <Dialog maxWidth="lg" onClose={handleCloseedit} aria-labelledby="customized-dialog-title" open={openedit}>
                     <DialogTitle id="customized-dialog-title" onClose={handleCloseedit} style={{ backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)"
, color: "white" }}>
                    Edit Student Information
                    <IconButton onClick={handleCloseedit} style={{float:"right"}}><CloseIcon style={{color:"white"}}/></IconButton>
                </DialogTitle>

                    <DialogContent dividers>



                        <div style={{ width: "100%", textAlign: "center" }}>



                            <input

                                style={{ display: "none" }}
                                id="fileimageedit"
                                multiple
                                type="file"
                                onChange={(e) => imagehandler(e)}
                            />
                            <label htmlFor="fileimageedit">
                                <Badge
                                    overlap="circular"
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                    badgeContent={
                                        <CameraAltIcon style={{ cursor: "pointer", backgroundColor: "darkblue", padding: 6, borderRadius: "100%", color: "white", fontSize: "26px" }} />
                                    }
                                >
                                    <Avatar style={{ width: 100, height: 100, border: "solid", borderColor: "#f0f0f0" }} alt="Travis Howard" src={person} />

                                </Badge>

                            </label>


                        </div>
                        <br />

                        <Divider><small> <b>STUDENT'S PERSONAL DETAILS </b></small></Divider>
                        <br />
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="lastnameedit"
                                placeholder="Lastname"
                                defaultValue={chosen.length!==0 && chosen.lastname}
                                type="text"
                                className="signup"
                                variant="outlined"
                                label="Surname"
                                size="small"



                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="othernamesedit"
                                placeholder="Other name(s)"
                                type="text"
                                defaultValue={chosen.length!==0 && chosen.othernames}
                                className="signup"
                                variant="outlined"
                                label="Othername(s)"
                                size="small"



                            />
                        </FormControl>
                        <br />

                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="dobedit"
                                label="Date Of Birth"
                                type="date"
                                defaultValue={chosen.length!==0 && chosen.dob ? chosen.dob : ""}

                                InputLabelProps={{
                                    shrink: true,
                                }}
                                className="signup"
                                size="small"
                            />
                        </FormControl>

                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="residenceedit"
                                placeholder="Residence Address"
                                type="address"
                                className="signup"
                                defaultValue={chosen.length!==0 && chosen.residence}
                                label="Residence Address"
                                size="small"



                            />
                        </FormControl>

                        <br />
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="hometownedit"
                                placeholder="Hometown"
                                type="text"
                                className="signup"
                                defaultValue={chosen.length!==0 && chosen.hometown}
                                variant="outlined"
                                label="Hometown"
                                size="small"



                            />
                        </FormControl>

                        <FormControl style={{ margin: 10 }}>
                            <InputLabel id="demo-simple-select-helper-label">Religion</InputLabel>
                            <Select
                                id="demo-simple-select-helperedit"
                                value={selectedreligionedit===""?chosen.religion:selectedreligionedit}
                                label="Religion"
                                className="signup"
                                
                                variant="outlined"
                                size="small"

                                onChange={handleChange_religionedit}
                            >
                                <MenuItem value="none"><em>Choose Religion</em></MenuItem>
                                <MenuItem value="Christianity">Christianity</MenuItem>
                                <MenuItem value="Islam">Islam</MenuItem>
                                <MenuItem value="Jainism">Jainism</MenuItem>
                                <MenuItem value="Judaism">Judaism</MenuItem>
                                <MenuItem value="Shinto">Shinto</MenuItem>

                            </Select>


                        </FormControl>

                        <br />

                        <FormControl style={{ margin: 10 }}>
                            <InputLabel id="demo-simple-select-helper-label">Gender</InputLabel>
                            <Select
                                id="demo-simple-select-helper_edit"
                                value={selectedgenderedit===""?chosen.gender:selectedgenderedit}
                                label="Gender"
                                className="signup"
                                variant="outlined"
                                size="small"
                                style={{ padding: 0 }}

                                onChange={handleChange_genderedit}
                            >
                                <MenuItem value="none"><em>Choose Gender</em></MenuItem>
                                <MenuItem value="Male">Male</MenuItem>
                                <MenuItem value="Female">Female</MenuItem>

                            </Select>


                        </FormControl>


                        <FormControl style={{ margin: 10 }}>
                            <InputLabel id="demo-simple-select-helper-label">Class</InputLabel>
                            <Select
                                id="demo-simple-select-helper__edit"
                                value={selectedclassedit===""?chosen.class_:selectedclassedit}
                                label="Class"
                                className="signup"
                                variant="outlined"
                                size="small"
                                onChange={handleChange_classedit}
                            >
                                <MenuItem value="none"> <em>Choose Class</em></MenuItem>
                                
                                {Class_.length !==0 ? Class_.map((list, index)=>
                                <MenuItem value={list.classname}>{list.classname}</MenuItem>
                                
                                ):""}
                                

                            </Select>

                        </FormControl>

                        <br />
                        <FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    id="indexedit"
    placeholder="Index Number"
    type="text"
    className="signup"
    variant="outlined"
    defaultValue={chosen.length!==0 && chosen.index}

    label="Index Number"
    size="small"



/>
</FormControl> 

<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    id="specialIDedit"
    placeholder="Special ID"
    type="text"
    className="signup"
    variant="outlined"
    defaultValue={chosen.length!==0 && chosen.specialID}

    label="Special ID"
    size="small"



/>
</FormControl>
<br/>
<FormControl style={{ margin: 10 }}>
                            <InputLabel id="demo-simple-select-helper-label">Housing</InputLabel>
                            <Select
                                id="housingedit"
                                value={housing}
                                label="Housing"
                                className="signup"
                                variant="outlined"
                                size="small"

                                onChange={(e)=>sethousing(e.target.value)}
                            >

                                <MenuItem value="Day">Day</MenuItem>
                                <MenuItem value="Boarding">Boarding</MenuItem>
                                

                            </Select>


                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    id="scholarshipedit"
    placeholder="Scholarchip"
    type="number"
    className="signup"
    variant="outlined"
    defaultValue={chosen.length!==0 && chosen.scholarship}
    label="Scholarchip"
    size="small"
    InputProps={{
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
      }}
/><TextField
    id="dailyfeeedit"
    placeholder="Daily Charges"
    type="number"
    className="signup"
    variant="outlined"
    defaultValue={chosen.length!==0 && chosen.dailycharge}
    label="Daily Charge"
    size="small"
    InputProps={{
        startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment>,
      }}
/>
                    </FormControl>

<br/>
<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    id="weeklyfeeedit"
    placeholder="Weekly Charges"
    type="number"
    className="signup"
    variant="outlined"
    defaultValue={chosen.length!==0 && chosen.weeklyfee}
    label="Weekly Charge"
    size="small"
    InputProps={{
        startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment>,
      }}
/>
</FormControl>
<FormControl variant="standard" style={{ margin: 10 }}>

<TextField
    id="monthlyfeeedit"
    placeholder="Monthly Charges"
    type="number"
    className="signup"
    variant="outlined"
    defaultValue={chosen.length!==0 && chosen.monthlyfee}
    label="Monthly Charge"
    size="small"
    InputProps={{
        startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment>,
      }}
/>
                    </FormControl>
                        <br />
                        <br />

                        <Divider><small> <b>STUDENT'S PARENTS DETAILS </b></small></Divider>

                        <p style={{ textAlign: "center" }}> <b>Mother</b></p>


                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="motherlastnameedit"
                                placeholder="Surname"
                                type="text"
                                defaultValue={chosen.length!==0 && chosen.motherlastname}
                                className="signup"
                                variant="outlined"
                                label="Surname"
                                size="small"



                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="motherothernamesedit"
                                placeholder="Other name(s)"
                                type="text"
                                defaultValue={chosen.length!==0 && chosen.motherothernames}
                                className="signup"
                                variant="outlined"
                                label="Othername(s)"
                                size="small"



                            />
                        </FormControl>
                        <br />


                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="motheroccupationedit"
                                placeholder="Occupation"
                                type="text"
                                defaultValue={chosen.length!==0 && chosen.motheroccupation}
                                className="signup"
                                variant="outlined"
                                label="Occupation"
                                size="small"



                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="mothercontactedit"
                                placeholder="Contact"
                                type="tel"
                                defaultValue={chosen.length!==0 && chosen.mothercontact}
                                className="signup"
                                variant="outlined"
                                label="Contact"
                                size="small"



                            />
                        </FormControl>
                        <br />


                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="motheremailedit"
                                placeholder="Email"
                                type="email"
                                defaultValue={chosen.length!==0 && chosen.motheremail}
                                className="signup"
                                variant="outlined"
                                label="Email"
                                size="small"



                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="motherresidenceedit"
                                placeholder="Address"
                                type="address"
                                defaultValue={chosen.length!==0 && chosen.motherresidence}
                                className="signup"
                                variant="outlined"
                                label="Address"
                                size="small"



                            />
                        </FormControl>
                        <br />


                        <p style={{ textAlign: "center" }}> <b>Father </b></p>


                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="fatherlastnameedit"
                                placeholder="Surname"
                                type="text"
                                defaultValue={chosen.length!==0 && chosen.fatherlastname}
                                className="signup"
                                variant="outlined"
                                size="small"

                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="fatherothernamesedit"
                                placeholder="Other name(s)"
                                type="text"
                                defaultValue={chosen.length!==0 && chosen.fatherothernames}
                                className="signup"
                                variant="outlined"
                                label="Othername(s)"
                                size="small"
                            />
                        </FormControl>
                        <br />


                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="fatheroccupationedit"
                                placeholder="Occupation"
                                type="text"
                                defaultValue={chosen.length!==0 && chosen.fatheroccupation}
                                className="signup"
                                variant="outlined"
                                label="Occupation"
                                size="small"

                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="fathercontactedit"
                                placeholder="Contact"
                                type="tel"
                                defaultValue={chosen.length!==0 && chosen.fathercontact}
                                className="signup"
                                variant="outlined"
                                label="Contact"
                                size="small"



                            />
                        </FormControl>
                        <br />


                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="fatheremailedit"
                                placeholder="Email"
                                type="email"
                                defaultValue={chosen.length!==0 && chosen.fatheremail}
                                className="signup"
                                variant="outlined"
                                label="Email"
                                size="small"



                            />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>

                            <TextField
                                id="fatherresidenceedit"
                                placeholder="Address"
                                type="address"
                                defaultValue={chosen.length!==0 && chosen.fatherresidence}
                                className="signup"
                                variant="outlined"
                                label="Address"
                                size="small"



                            />
                        </FormControl>
                        <br />
                        <br />
                        <Divider><small> <b>GUARDIAN </b></small></Divider>
                        <br />

                        <FormControl>
                            {/* <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel> */}
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                id="guardianedit"
                                value={guardianedit===""?chosen.guardianrelationship:guardianedit}
                                onChange={guardianchangeedit}
                            >
                                <FormControlLabel value="Mother" control={<Radio />} label="Mother" />
                                <FormControlLabel value="Father" control={<Radio />} label="Father" />
                                <FormControlLabel value="Parents" control={<Radio />} label="Parents" />
                                <FormControlLabel value="Others" control={<Radio />} label="Others" />
                                
                            </RadioGroup>
                        </FormControl>
                        <br/>
                        {guardianedit === "Others" && (
                        
                        <div>

                        <p style={{textAlign:"center"}}>Fill this if Guardian is not a parent </p>
                        
                        <FormControl variant="standard" style={{ margin: 10 }}>
                        
                        <TextField
                            id="guardianlastnameedit"
                            placeholder="Surname"
                            type="text"
                            className="signup"
                            variant="outlined"
                            defaultValue={chosen.length!==0 && chosen.guardiansurnameedit}

                            size="small"
                        
                        
                        />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>
                        
                        <TextField
                            id="guardianothernamesedit"
                            placeholder="Other name(s)"
                            type="text"
                            defaultValue={chosen.length!==0 && chosen.guardianothernames}

                            className="signup"
                            variant="outlined"
                            label="Othername(s)"
                            size="small"
                        
                        
                        
                        />
                        </FormControl>
                        <br />
                        
                        
                        <FormControl variant="standard" style={{ margin: 10 }}>
                        
                        <TextField
                            id="guardianoccupationedit"
                            placeholder="Occupation"
                            type="text"
                            defaultValue={chosen.length!==0 && chosen.guardianoccupation}

                           
                            className="signup"
                            variant="outlined"
                            label="Occupation"
                            size="small"
                        
                        
                        
                        />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>
                        
                        <TextField
                            id="guardiancontactedit"
                            placeholder="Contact"
                            type="tel"
                            defaultValue={chosen.length!==0 && chosen.guardiancontact}

                            className="signup"
                            variant="outlined"
                            label="Contact"
                            size="small"
                        
                        
                        
                        />
                        </FormControl>
                        <br />
                        
                        
                        <FormControl variant="standard" style={{ margin: 10 }}>
                        
                        <TextField
                            id="guardianemailedit"
                            placeholder="Email"
                            type="email"
                            defaultValue={chosen.length!==0 && chosen.guardianemail}

                            className="signup"
                            variant="outlined"
                            label="Email"
                            size="small"
                        
                        
                        
                        />
                        </FormControl>
                        <FormControl variant="standard" style={{ margin: 10 }}>
                        
                        <TextField
                            id="guardianaddressedit"
                            placeholder="Address"
                            type="address"
                            defaultValue={chosen.length!==0 && chosen.guardianaddress}

                            className="signup"
                            variant="outlined"
                            label="Address"
                            size="small"
                        
                        
                        
                        />
                        </FormControl>
                        <br />
                        
                                        </div>
                        )}

                        <br />
                        <div style={{ textAlign: "center" }}>

                          


                        </div>
                    </DialogContent>

                    <DialogActions>
                     {editstudentloading ===true?
                               <LoadingButton
        loading
        loadingPosition="start"
        startIcon={<SaveIcon />}
        variant="outlined"
      >
        Loading...
      </LoadingButton>:
                          
                                <Button
                                  autoFocus
                                  onClick={() => {
                                    try {
                                      editstudent();
                                    } catch (err) {
                                      console.error("editstudent runtime error:", err);
                                      handleClicksnack();
                                      setmessage("Unable to update student. Please refresh and try again.");
                                      setstated("error");
                                      seteditstudentloading(false);
                                    }
                                  }}
                                  style={{backgroundColor:" #e0eff9" , color:"#1976d2"}}
                                >
                                    Submit
                                </Button>
                            }
                       
                    </DialogActions>
                </Dialog>
         
            <Paper sx={{ width: '100%', mb: 2 }}>
                <EnhancedTableToolbar numSelected={selected.length} onPrint={componentRef} onExport={handleExportToExcel} onImport={handleClickOpenaddexcel} onAdd={handleClickOpenadd} />
                
                <div className="no-print">
                <Grid container spacing={2} style={{ padding: 10 }}>
                    <Grid item lg={3} xs={12} md={6}>
                        <FormControl style={{ minWidth: 150, marginTop: 10 }}>
                            <InputLabel id="class-filter-label">Filter by Class</InputLabel>
                            <Select
                                labelId="class-filter-label"
                                id="class-filter"
                                value={sortclass}
                                label="Filter by Class"
                                onChange={handleChangesortclass}
                                style={{ height: "38px" }}
                            >
                                <MenuItem value="none">All Classes</MenuItem>
                                {Class_.length !== 0 && Class_.map((list, index) => (
                                    <MenuItem key={index} value={list.classname}>{list.classname}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item lg={6} xs={12} md={6}>
                        <Search id="searchbox" style={{ position: "absolute", marginTop: "18px", marginLeft: "8px", color: "grey" }} />
                        <input 
                            type="search" 
                            onChange={(e) => searching(e)} 
                            placeholder="Search by ID, Name, Class, Status..." 
                            value={search}
                            style={{ 
                                padding: 10, 
                                paddingLeft: "38px", 
                                marginTop: 10, 
                                width: "100%", 
                                border: "solid", 
                                borderRadius: "5px", 
                                borderWidth: "0.5px", 
                                backgroundColor: "rgba(65,105,225, 0.05)", 
                                borderColor: "#2196f3" 
                            }} 
                        />
                    </Grid>

                    <Grid item lg={5} sm={12} md={12}>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Grid>
                </Grid>
                </div>

                <Divider />

                {/* Print-only table with all students */}
                <div ref={componentRef} style={{ display: 'none' }}>
                    <div style={{textAlign:"center", padding:"10px", marginBottom:"20px"}}>
                        {schooldetails_ && schooldetails_.length > 0 && (
                            <>
                                {schooldetails_[0].image && (
                                    <img 
                                        src={`https://thesis1995revolution0268005074.sisrevolution.com/sisrevolution1995/routes/logothumb/${schooldetails_[0].image}`} 
                                        width="80px" 
                                        alt="school logo" 
                                        style={{marginBottom:"10px"}}
                                    />
                                )}
                                <h3 style={{margin:4, color:"#1976d2"}}>
                                    {schooldetails_[0].schoolname && schooldetails_[0].schoolname.toUpperCase()}
                                </h3>
                                {schooldetails_[0].address && (
                                    <p style={{margin:4, color:"#666"}}>
                                        {schooldetails_[0].address.toUpperCase()}
                                    </p>
                                )}
                            </>
                        )}
                        <h4 style={{margin:10, borderTop:"2px solid #1976d2", paddingTop:"10px"}}>STUDENTS LIST</h4>
                        <p style={{margin:4, fontSize:"12px", color:"#666"}}>
                            Generated on: {new Date().toLocaleDateString()} at {new Date().toLocaleTimeString()}
                        </p>
                        <p style={{margin:4, fontSize:"12px", color:"#666", fontWeight:"bold"}}>
                            Total Students: {rows.length}
                        </p>
                    </div>

                <TableContainer>
                    <Table
                            sx={{ minWidth: 750, fontSize: '10px' }}
                            aria-labelledby="tableTitle"
                            size="small"
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" style={{fontWeight:"bold", fontSize:"9px"}}>No.</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>ID</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Name</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Special ID</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Index No.</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Status</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Class</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Gender</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Date of Birth</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Hometown</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Residence</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Religion</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Housing</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Daily Charge</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Mother Name</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Mother Contact</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Father Name</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Father Contact</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Guardian Name</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Guardian Contact</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Guardian Relationship</TableCell>
                                    <TableCell align="left" style={{fontWeight:"bold", fontSize:"9px"}}>Next Class</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {stableSort(rows, getComparator(order, orderBy))
                                    .map((row, index) => {
                                        const motherName = row.motherlastname && row.motherothernames 
                                            ? `${row.motherlastname} ${row.motherothernames}` 
                                            : (row.motherlastname || row.motherothernames || '');
                                        const fatherName = row.fatherlastname && row.fatherothernames 
                                            ? `${row.fatherlastname} ${row.fatherothernames}` 
                                            : (row.fatherlastname || row.fatherothernames || '');
                                        const guardianName = row.guardianlastname && row.guardianothernames 
                                            ? `${row.guardianlastname} ${row.guardianothernames}` 
                                            : (row.guardianlastname || row.guardianothernames || '');
                                        
                                        return (
                                            <TableRow key={row._id}>
                                                <TableCell style={{ textAlign: "center", fontSize:"9px" }}>
                                                    <span>{(index + 1) + "."}</span>
                                                </TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.id || ''}</TableCell>
                                                <TableCell component="th" scope="row" padding="none" align="left" style={{fontSize:"9px"}}>
                                                    {row.lastname + " " + row.othernames}
                                                </TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.specialID || ''}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.index || 'N/A'}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.status || ''}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.class_ || ''}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.gender || ''}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>
                                                    {row.dob ? (() => {
                                                        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                                                        const parts = row.dob.split("-");
                                                        if (parts.length === 3) {
                                                            return `${months[parseInt(parts[1]) - 1]} ${parts[2]}, ${parts[0]}`;
                                                        }
                                                        return row.dob;
                                                    })() : ''}
                                                </TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.hometown || ''}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.residence || ''}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.religion || ''}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.housing || ''}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>
                                                    {row.dailycharge ? `${currencySymbol} ${row.dailycharge}` : ''}
                                                </TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{motherName}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.mothercontact || ''}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{fatherName}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.fathercontact || ''}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{guardianName}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.guardiancontact || ''}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.guardianrelationship || ''}</TableCell>
                                                <TableCell align="left" style={{fontSize:"9px"}}>{row.nextclass || ''}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

                {/* Visible table with pagination */}
                <TableContainer>
                    <Table
                        sx={{ minWidth: 750 }}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                    >
                        <EnhancedTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                        />
                        <TableBody>
                            {stableSort(rows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const isItemSelected = isSelected(row._id);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={row._id}
                                            selected={isItemSelected}
                                        >
                                            <TableCell padding="checkbox" className="no-print">
                                                <Checkbox
                                                    color="primary"
                                                    checked={isItemSelected}
                                                    inputProps={{
                                                        'aria-labelledby': labelId,
                                                    }}
                                                    onChange={(event) => {
                                                        const selectedIndex = selected.indexOf(row._id);
                                                        let newSelected = [];

                                                        if (selectedIndex === -1) {
                                                            newSelected = newSelected.concat(selected, row._id);
                                                        } else if (selectedIndex === 0) {
                                                            newSelected = newSelected.concat(selected.slice(1));
                                                        } else if (selectedIndex === selected.length - 1) {
                                                            newSelected = newSelected.concat(selected.slice(0, -1));
                                                        } else if (selectedIndex > 0) {
                                                            newSelected = newSelected.concat(
                                                                selected.slice(0, selectedIndex),
                                                                selected.slice(selectedIndex + 1),
                                                            );
                                                        }
                                                        setSelected(newSelected);
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell style={{ textAlign: "center" }}>
                                                <span>
                                                    {(index + 1 + (page * rowsPerPage)) + "."}
                                                </span>
                                            </TableCell>
                                            <TableCell align="left">{row.id}</TableCell>
                                            <TableCell component="th" id={labelId} scope="row" padding="none" align="left">
                                                <ListItem align="left">
                                                    <ListItemAvatar>
                                                        <Avatar 
                                                            src={getStudentThumbnailUrl(row) || undefined}
                                                            alt={row.lastname + " " + row.othernames}
                                                            sx={{ width: 40, height: 40 }}
                                                            onClick={() => handleClickOpenimage(row)}
                                                            style={{ cursor: "pointer" }}
                                                            imgProps={{
                                                                onError: (e) => {
                                                                    const full = getStudentFullImageUrl(row);
                                                                    if (full && e.currentTarget.src !== full) {
                                                                        e.currentTarget.src = full;
                                                                        return;
                                                                    }
                                                                    e.currentTarget.removeAttribute('src');
                                                                }
                                                            }}
                                                        >
                                                            <PersonIcon />
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText primary={row.lastname + " " + row.othernames} />
                                                </ListItem>
                                            </TableCell>
                                            <TableCell align="left">
                                                {row.status === "Active" ? 
                                                    <span style={{padding:8, borderRadius:"20px", backgroundColor:"#13A518", color:"white"}}>{row.status}</span> :
                                                    row.status === "Completed" ? 
                                                    <span style={{padding:8, borderRadius:"20px", backgroundColor:"blue", color:"white"}}>{row.status}</span> : 
                                                    <span style={{padding:8, borderRadius:"20px", backgroundColor:"red", color:"white"}}>{row.status}</span>
                                                }
                                            </TableCell>
                                            <TableCell align="left">{row.class_}</TableCell>
                                            <TableCell align="left">{row.gender}</TableCell>
                                            <TableCell align="left">{row.dob}</TableCell>
                                            <TableCell align="left">{row.residence}</TableCell>
                                            <TableCell align="left">
                                                <Menustyle 
                                                    data={row} 
                                                    view={(sender) => handleClickOpenview(sender)} 
                                                    message={(sender) => handleClickOpenmessage(sender)}
                                                    attendance={(sender) => handleClickOpenattendance(sender)}
                                                    showAcademicRecords={false}
                                                    printAdmission={(sender) => downloadAdmissionForm(sender)}
                                                    generateTranscript={(sender) => handleClickOpentranscript(sender)}
                                                    status={(sender) => handleClickOpenstatus(sender)}
                                                    edit={(sender) => handleClickOpenedit(sender)} 
                                                    delete={(sender) => handleClickOpendelete(sender)}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow
                                    style={{
                                        height: (dense ? 33 : 53) * emptyRows,
                                    }}
                                >
                                    <TableCell colSpan={10} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Show message when there are more pages */}
                {(page + 1) * rowsPerPage < rows.length && (
                    <Box sx={{ textAlign: 'center', padding: 2, color: '#1976d2' }}>
                        <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                            Click next page to see more students ({rows.length - ((page + 1) * rowsPerPage)} more)
                        </Typography>
                    </Box>
                )}
                
                <div className="no-print">
            <FormControlLabel
                control={<Switch checked={dense} onChange={handleChangeDense} />}
                label="Dense padding"
            />
                </div>
            </Paper>

        </Box>
    );
}
